<template>
  <div>
    <confirm ref="confirmStorno" @selection="cancelReceipt" />
    <confirm ref="confirmFiscalize" @selection="fiscalizeReceipt" />
    <confirm ref="confirmCreateEracun" @selection="openEracunEmailDialog" />
    <confirm ref="confirmCreateEizvjestavanje" @selection="createEizvjestavanje" />

    <!-- eRačun Email Dialog -->
    <v-dialog
      v-model="eracunEmailDialog"
      max-width="500"
      persistent
    >
      <v-card class="glass-card-eracun">
        <div class="glass-header-eracun">
          <div class="header-pattern"></div>
          <v-card-title class="headline-eracun white--text">
            Unesite Email adresu kontakta Kupca
          </v-card-title>
        </div>
        <v-card-text class="pt-6 pb-4">
          <v-text-field
            v-model="eracunEmail"
            label="Email adresa kontakta Kupca"
            type="email"
            outlined
            dense
            :rules="[v => !!v || 'Email je obavezan', rules.email]"
            class="filter-select"
            @keyup.enter="createEracunWithEmail"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="pb-4 px-4">
          <v-spacer></v-spacer>
          <v-btn
            text
            class="cancel-btn-eracun"
            @click="closeEracunEmailDialog"
          >
            Odustani
          </v-btn>
          <v-btn
            class="primary-btn-eracun"
            :disabled="!isValidEmail"
            @click="createEracunWithEmail"
          >
            <v-icon small class="mr-1">mdi-email-send</v-icon>
            Kreiraj eRačun
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container>
      <div v-if="modal && !hideFilter">
        <v-col cols="4" sm="4" md="3" xl="2" class="pa-0 ma-0">
          <v-select
            label="Status"
            v-model="statusFilter"
            :items="filters"
            return-object
            item-text="name"
            item-value="value"
          >
            <template v-slot:item="{ item }">
              {{ item.name }}
            </template>
          </v-select>
        </v-col>
      </div>
      <v-row class="justify-center">
        <v-col
          cols="12"
          sm="11"
          lg="11"
          :class="['px-0']"
          style="position: relative"
        >
          <!-- Table Header with Filters -->
          <div v-if="!modal" class="table-header-filters">
            <!-- Primary row -->
            <div class="toolbar-grid">
              <v-select
                label="Tip dokumenta"
                v-model="reciptOffer"
                :items="reciptOfferChoices"
                item-text="name"
                item-value="value"
                @change="getReceiptsOrOffers"
                dense outlined hide-details
                class="filter-select">
              </v-select>
              <v-menu v-model="dateFromMenu" offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined dense hide-details
                    :value="dateFrom ? new Intl.DateTimeFormat('hr-HR', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(dateFrom)) : ''"
                    label="Od datuma"
                    prepend-inner-icon="mdi-calendar"
                    readonly clearable
                    @click:clear="dateFrom = null"
                    v-bind="attrs" v-on="on"
                    class="filter-select">
                  </v-text-field>
                </template>
                <v-date-picker v-model="dateFrom" no-title scrollable @input="dateFromMenu = false"></v-date-picker>
              </v-menu>
              <v-menu v-model="dateToMenu" offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined dense hide-details
                    :value="dateTo ? new Intl.DateTimeFormat('hr-HR', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(dateTo)) : ''"
                    label="Do datuma"
                    prepend-inner-icon="mdi-calendar"
                    readonly clearable
                    @click:clear="dateTo = null"
                    v-bind="attrs" v-on="on"
                    class="filter-select">
                  </v-text-field>
                </template>
                <v-date-picker v-model="dateTo" no-title scrollable @input="dateToMenu = false"></v-date-picker>
              </v-menu>
              <v-select
                :label="$t('$vuetify.companyTabs.pointsOfSale')"
                v-model="location"
                :items="locs"
                return-object
                item-text="name"
                item-value="location_id"
                dense outlined hide-details
                class="filter-select">
                <template v-slot:item="{ item }">
                  {{ item.name }}{{ item.id !== "" ? "," : "" }}
                  {{ item.address }}
                </template>
              </v-select>
              <div class="toolbar-grid__actions">
                <v-btn text small class="advanced-toggle-btn" @click="showAdvanced = !showAdvanced">
                  <v-icon small class="mr-1">{{ showAdvanced ? 'mdi-chevron-up' : 'mdi-tune' }}</v-icon>
                  {{ showAdvanced ? 'Sakrij' : 'Filteri' }}
                  <v-badge v-if="activeAdvancedCount > 0" :content="activeAdvancedCount" color="#3989C9" inline class="ml-1"></v-badge>
                </v-btn>
                <v-btn class="search-btn" @click="applyFilter" :loading="isLoadingReceipts" elevation="0">
                  <v-icon small class="mr-1">mdi-magnify</v-icon>
                  Pretraži
                </v-btn>
              </div>
            </div>

            <!-- Advanced filters row — same 5-column grid -->
            <v-expand-transition>
              <div v-show="showAdvanced" class="advanced-filters-panel">
                <div class="toolbar-grid">
                  <v-select
                    label="Status"
                    v-model="statusFilter"
                    :items="filters"
                    return-object
                    item-text="name"
                    item-value="value"
                    dense outlined hide-details
                    class="filter-select">
                    <template v-slot:item="{ item }">{{ item.name }}</template>
                  </v-select>
                  <v-combobox
                    label="Klijent"
                    :placeholder="$t('$vuetify.filterPlaceholderLabel')"
                    v-model="oibFilter"
                    :loading="loading"
                    :items="associates"
                    :search-input.sync="clientSearchInput"
                    return-object
                    item-text="name"
                    @change="applyFilter"
                    hide-no-data
                    clearable
                    @click:clear="applyFilter"
                    dense outlined hide-details
                    class="uppercased-input filter-select">
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item class="uppercased-input" v-on="on" v-bind="attrs">{{ item.name }}</v-list-item>
                    </template>
                  </v-combobox>
                  <v-text-field
                    v-model="oibFilterManual"
                    label="OIB"
                    @keydown.enter="applyFilter"
                    @click:clear="resetField('oibManual')"
                    dense outlined hide-details
                    class="filter-select">
                  </v-text-field>
                  <v-text-field
                    v-model="receiptNumberFilter"
                    :label="$t('$vuetify.filterReceiptNumber')"
                    @keydown.enter="applyFilter()"
                    dense outlined hide-details
                    class="filter-select">
                  </v-text-field>
                  <v-select
                    v-if="reciptOffer === 'receipts'"
                    label="Način plaćanja"
                    v-model="paymentMethodFilter"
                    :items="paymentMethods"
                    item-text="name"
                    item-value="value"
                    @change="applyFilter"
                    dense outlined hide-details
                    class="filter-select"
                    clearable>
                  </v-select>
                </div>
              </div>
            </v-expand-transition>
          </div>

          <!-- Virman Selection Toolbar -->
          <v-row
            v-if="reciptOffer === 'virmans' && !modal"
            class="align-center virman-selection-toolbar"
          >
            <v-col cols="auto">
              <v-select
                v-model="virmanPaymentFilter"
                :items="virmanPaymentFilterOptions"
                item-text="name"
                item-value="value"
                label="Status"
                dense
                solo
                flat
                hide-details
                style="min-width: 150px;"
              ></v-select>
            </v-col>
            <v-col cols="auto">
              <v-checkbox
                v-model="selectAllVirmans"
                @change="toggleSelectAllVirmans"
                label="Označi sve"
                hide-details
                dense
              ></v-checkbox>
            </v-col>
            <v-col cols="auto" v-if="selectedVirmans.length > 0">
              <v-chip color="primary" small>
                Odabrano: {{ selectedVirmans.length }}
              </v-chip>
            </v-col>
            <v-col cols="auto" v-if="canCreateReceiptFromVirmans">
              <v-btn
                color="success"
                @click="createReceiptFromMultipleVirmans"
                :disabled="!canCreateReceiptFromVirmans"
                small
              >
                <v-icon left small>mdi-file-document-plus</v-icon>
                Izradi račun
              </v-btn>
            </v-col>
            <v-col cols="auto" v-if="selectedVirmans.length > 0">
              <v-btn
                text
                color="error"
                @click="clearVirmanSelection"
                small
              >
                Poništi odabir
              </v-btn>
            </v-col>
          </v-row>

          <!-- Loading overlay samo na račune -->
          <div v-if="isLoadingReceipts" class="loading-overlay-receipts">
            <v-progress-circular
              indeterminate
              size="64"
              class="loading-spinner"
            ></v-progress-circular>
          </div>

          <div class="receipts-rows-body">
          <v-expansion-panels focusable>
            <v-expansion-panel
              v-for="(receipt, i) in receipts"
              :key="i"
              hover
              tabindex="0"
              :class="[
                receipt.payment_method !== 'TRANSAKCIJSKI RAČUN' &&
                receipt.type.flag !== 'P' &&
                receipt.fiscalize === true &&
                receipt.zki !== '' &&
                receipt.jir === '' &&
                issueBefore(receipt.issue_date_time) > now
                  ? 'status-failed-exp'
                  : 'status-ok-exp',
                receipt.payment_method !== 'TRANSAKCIJSKI RAČUN' &&
                receipt.type.flag !== 'P' &&
                receipt.fiscalize === true &&
                receipt.zki !== '' &&
                receipt.jir === '' &&
                issueBefore(receipt.issue_date_time) < now
                  ? 'status-failed-expired'
                  : 'status-ok-exp',
                receipt.payment_method === 'TRANSAKCIJSKI RAČUN' &&
                receipt.type.flag !== 'P' &&
                (!receipt.payment_due ||
                  parseInt(receipt.payment_due) > now) &&
                receipt.payment !== undefined &&
                receipt.payment.current_status !== 'PAID'
                  ? 'status-warn-exp'
                  : '',
                receipt.payment_method === 'TRANSAKCIJSKI RAČUN' &&
                receipt.type.flag !== 'P' &&
                parseInt(receipt.payment_due) < now &&
                receipt.payment !== undefined &&
                receipt.payment.current_status !== 'PAID'
                  ? 'status-warn-after-exp'
                  : '',
                receipt.payment_method === 'TRANSAKCIJSKI RAČUN' &&
                receipt.type.flag !== 'P' &&
                receipt.payment !== undefined &&
                receipt.payment.current_status === 'PAID'
                  ? 'status-ok-exp'
                  : '',
                receipt.payment_method === 'TRANSAKCIJSKI RAČUN' &&
                receipt.type.flag === 'P'
                  ? 'status-ok-exp'
                  : '',
                receipt.payment !== undefined &&
                receipt.payment.current_status === 'REVERSED'
                  ? 'status-reversed'
                  : '',
                receipt.type.flag === 'STORNO' ? 'status-storno' : '',
                receipt.payment_method === 'TRANSAKCIJSKI RAČUN' &&
                receipt.payment.current_status === 'UNCOLLECTIBLE'
                  ? 'status-uncollectible'
                  : '',
                reciptOffer === 'virmans'
                  ? (isVirmanPaid(receipt) ? 'virman-paid' : 'virman-unpaid')
                  : '',
              ]"
            >
              <v-expansion-panel-header
                height="200"
                hide-actions
              >
                <v-row align="center">
                  <!-- Checkbox za virman selekciju -->
                  <v-col
                    v-if="reciptOffer === 'virmans'"
                    cols="1"
                    class="d-flex align-center justify-center"
                    @click.stop
                  >
                    <v-checkbox
                      :value="isVirmanSelected(receipt)"
                      @click.stop="toggleVirmanSelection(receipt)"
                      :disabled="isVirmanPaid(receipt)"
                      hide-details
                      dense
                      color="#00BCD4"
                    ></v-checkbox>
                  </v-col>
                  <!-- Status chip za virmane -->
                  <v-col
                    v-if="reciptOffer === 'virmans'"
                    cols="1"
                    class="d-flex align-center justify-center"
                  >
                    <v-chip
                      v-if="isVirmanPaid(receipt)"
                      x-small
                      outlined
                      color="success"
                      class="virman-status-pill"
                    >
                      Naplaćen
                    </v-chip>
                    <v-chip
                      v-else
                      x-small
                      outlined
                      color="warning"
                      class="virman-status-pill"
                    >
                      Nenaplaćen
                    </v-chip>
                  </v-col>
                  <!-- Ikone za fiskalizaciju i eRačun -->
                  <v-col
                    v-if="reciptOffer !== 'virmans' && reciptOffer !== 'offers'"
                    cols="auto"
                    :class="[densityPadding]"
                    style="padding-right: 0; max-width: 60px; min-width: 60px;"
                  >
                    <div class="caption grey--text text-center">Fisk.</div>
                    <div class="d-flex justify-center align-center" style="gap: 4px;">
                    <!-- Fiskalizacija ikona - Zelena (potpuno fiskalizirano - ima ZKI i JIR) -->
                    <v-tooltip bottom v-if="receipt.zki && receipt.jir">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          color="success"
                          v-bind="attrs"
                          v-on="on"
                        >mdi-cash-register</v-icon>
                      </template>
                      <span>Fiskalizirano<br>ZKI: {{ receipt.zki }}<br>JIR: {{ receipt.jir }}</span>
                    </v-tooltip>
                    <!-- Fiskalizacija ikona - Žuta (polufiskalizirano - ima ZKI ali nema JIR) -->
                    <v-tooltip bottom v-else-if="receipt.zki && !receipt.jir">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          color="warning"
                          v-bind="attrs"
                          v-on="on"
                        >mdi-cash-register</v-icon>
                      </template>
                      <span>Polufiskalizirano<br>ZKI: {{ receipt.zki }}<br>(nema JIR)</span>
                    </v-tooltip>
                    <!-- eRačun ikona - Plava -->
                    <v-tooltip bottom v-if="receipt.hasEracun">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >mdi-file-document-outline</v-icon>
                      </template>
                      <span>eRačun kreiran</span>
                    </v-tooltip>
                    <!-- eRačun ikona - Crvena (greška) -->
                    <v-tooltip bottom v-if="receipt.hasEracunError">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          color="#D32F2F"
                          v-bind="attrs"
                          v-on="on"
                        >mdi-alert-circle</v-icon>
                      </template>
                      <span>Račun nije uspješno kreiran. Pokušajte ga kreirati ponovno.</span>
                    </v-tooltip>
                    </div>
                  </v-col>
                  <v-col
                    :cols="reciptOffer === 'virmans' ? 2 : 2"
                    :sm="reciptOffer === 'virmans' ? 2 : 2"
                    :md="reciptOffer === 'virmans' ? 2 : 2"
                    :lg="reciptOffer === 'virmans' ? 2 : 2"
                    :xl="reciptOffer === 'virmans' ? 2 : 2"
                    :class="[densityPadding]"
                    :style="reciptOffer !== 'virmans' ? 'padding-left: 0;' : ''"
                  >
                    <div class="caption grey--text text-left">
                      {{
                        reciptOffer === "virmans" ? "Broj" : reciptOffer === "offers" ? "Ponuda" : "Račun"
                      }}
                    </div>
                    <div
                      class="text-left receipt-number-value"
                      v-html="receipt.receiptNumber"
                    ></div>
                  </v-col>
                  <v-col
                    :cols="reciptOffer === 'virmans' ? 2 : 2"
                    :sm="reciptOffer === 'virmans' ? 2 : 2"
                    :md="reciptOffer === 'virmans' ? 2 : 2"
                    :lg="reciptOffer === 'virmans' ? 2 : 2"
                    :xl="reciptOffer === 'virmans' ? 2 : 2"
                    :style="'min-width: 0; flex-grow: 1; max-width: none;'"
                    :class="[densityPadding]"
                  >
                    <div class="caption grey--text">
                      {{ $t("$vuetify.receipts.customer") }}
                    </div>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div class="text-capitalize text-truncate" v-bind="attrs" v-on="on">{{ receipt.customer }}</div>
                      </template>
                      <span>{{ receipt.customer }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col
                    cols="auto"
                    :class="[densityPadding]"
                    style="min-width: 110px;"
                  >
                    <div class="caption grey--text text-right" style="white-space: nowrap;">
                      {{
                        reciptOffer === "receipts"
                          ? $t("$vuetify.receipts.receiptPrice")
                          : $t("$vuetify.receipts.offerPrice")
                      }}
                    </div>
                    <div class="text-right receipt-amount-value">
                      {{ receipt.total | money(100, receipt.currency) }}
                    </div>
                  </v-col>
                  <v-col
                    :cols="reciptOffer === 'virmans' ? 2 : 2"
                    :sm="reciptOffer === 'virmans' ? 2 : 2"
                    :md="reciptOffer === 'virmans' ? 2 : 2"
                    :lg="reciptOffer === 'virmans' ? 2 : 2"
                    :xl="reciptOffer === 'virmans' ? 2 : 2"
                    :class="[densityPadding]"
                  >
                    <div class="caption grey--text text-center">
                      {{ $t("$vuetify.receipts.receiptIssueDate") }}
                    </div>
                    <div class="text-center text-truncate">
                      {{ receipt.issue_date_time | local }}
                    </div>
                  </v-col>
                  <v-col
                    cols="auto"
                    :class="[densityPadding, 'd-none', 'd-md-block']"
                    style="max-width: 130px; min-width: 130px; overflow: hidden;"
                  >
                    <div class="caption grey--text text-right">
                      Status
                    </div>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div class="text-right receipt-status-value" :class="{ 'receipt-status-value--offer': reciptOffer === 'offers' }" style="white-space: nowrap;" v-bind="attrs" v-on="on">
                          {{
                            $t(
                              `$vuetify.receipts.${
                                receipt.payment
                                  ? receipt.payment.current_status
                                  : "UNKNOWN_STATUS"
                              }`
                            )
                          }}
                        </div>
                      </template>
                      <span>{{
                        $t(
                          `$vuetify.receipts.${
                            receipt.payment
                              ? receipt.payment.current_status
                              : "UNKNOWN_STATUS"
                          }`
                        )
                      }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col
                    cols="auto"
                    class="d-flex justify-end align-center ml-auto"
                    :class="[densityPadding]"
                    style="z-index: 999; flex-grow: 0; flex-shrink: 0;"
                  >
                    <v-btn
                      min-height="30"
                      min-width="25"
                      plain
                      rounded
                      @click.native.stop
                      @keypress.enter.prevent="openMenu(receipt)"
                      @click="openMenu(receipt)"
                    >
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" sm="5">
                    <div
                      v-if="
                        receipt.payment_method === 'TRANSAKCIJSKI RAČUN' &&
                        receipt.payment.current_status !== 'PAID'
                      "
                      class="d-flex justify-space-between text-center text-subtitle-2"
                    >
                      <span style="font-weight: 600;">Rok plaćanja:</span>
                      {{ showPaymentDueDays(receipt.payment_due) }}
                    </div>
                    <div
                      class="d-flex justify-space-between text-center text-subtitle-2"
                    >
                      <span style="font-weight: 600;">Operater:</span> {{ receipt.seller_id }}
                    </div>
                    <div
                      class="d-flex justify-space-between text-center text-subtitle-2"
                    >
                      <span style="font-weight: 600;">Način plaćanja:</span> {{ receipt.payment_method }}
                    </div>
                    <div
                      v-if="receipt.payment_due && reciptOffer !== 'virmans'"
                      class="d-flex justify-space-between text-center text-subtitle-2"
                    >
                      <span style="font-weight: 600;">Dospijeće:</span> {{ formatDateOnly(receipt.payment_due) }}
                    </div>
                  </v-col>
                  <v-col
                    v-if="receipt.type && (receipt.type.payer_name || receipt.type.payer_oib)"
                    cols="12"
                    sm="7"
                  >
                    <div
                      v-if="receipt.type.payer_name"
                      class="d-flex justify-space-between text-center text-subtitle-2"
                    >
                      <span style="font-weight: 600;">Naziv:</span> {{ receipt.type.payer_name }}
                    </div>
                    <div
                      v-if="receipt.type.payer_address"
                      class="d-flex justify-space-between text-center text-subtitle-2"
                    >
                      <span style="font-weight: 600;">Adresa:</span> {{ receipt.type.payer_address }}
                    </div>
                    <div
                      v-if="receipt.type.payer_city"
                      class="d-flex justify-space-between text-center text-subtitle-2"
                    >
                      <span style="font-weight: 600;">Grad:</span> {{ receipt.type.payer_city }}
                    </div>
                    <div
                      v-if="receipt.type.payer_oib"
                      class="d-flex justify-space-between text-center text-subtitle-2"
                    >
                      <span style="font-weight: 600;">OIB:</span> {{ receipt.type.payer_oib }}
                    </div>
                  </v-col>
                </v-row>
                <v-list>
                  <v-row dense>
                    <v-col cols="auto" style="width: 48px; flex: 0 0 48px;">
                      <div
                        class="text-center text-subtitle-2 one-liner-text font-weight-bold"
                      >
                        R. br.
                      </div>
                    </v-col>
                    <v-col style="min-width: 0; flex-grow: 1; max-width: none;">
                      <div
                        class="text-left text-subtitle-2 one-liner-text font-weight-bold"
                      >
                        Naziv
                      </div>
                    </v-col>
                    <v-col cols="auto" style="width: 80px; flex: 0 0 80px;">
                      <div
                        class="text-right text-subtitle-2 one-liner-text font-weight-bold"
                      >
                        Količina
                      </div>
                    </v-col>
                    <v-col cols="auto" style="width: 120px; flex: 0 0 120px;">
                      <div
                        class="text-right text-subtitle-2 one-liner-text font-weight-bold"
                      >
                        Jedinična cijena
                      </div>
                    </v-col>
                    <v-col cols="auto" style="width: 100px; flex: 0 0 100px;">
                      <div
                        class="text-right text-subtitle-2 one-liner-text font-weight-bold"
                      >
                        Cijena
                      </div>
                    </v-col>
                  </v-row>
                  <v-list-item
                    v-for="(item, index) in receipt.items"
                    :key="index"
                    class="pa-0"
                    style="min-height: unset;"
                  >
                    <v-row class="pa-0" dense>
                      <v-col cols="auto" style="width: 48px; flex: 0 0 48px;">
                        <div class="text-center text-subtitle-2">
                          {{ index + 1 }}
                        </div>
                      </v-col>
                      <v-col style="min-width: 0; flex-grow: 1; max-width: none;">
                        <div class="text-left text-subtitle-2">
                          {{ item.name }}
                        </div>
                      </v-col>
                      <v-col cols="auto" style="width: 80px; flex: 0 0 80px;">
                        <div class="text-right text-subtitle-2">
                          {{ formatQty(item.amt) }}
                        </div>
                      </v-col>
                      <v-col cols="auto" style="width: 120px; flex: 0 0 120px;">
                        <div class="text-right text-subtitle-2">
                          {{
                            item.single_item_price
                              | money(100, receipt.currency)
                          }}
                        </div>
                      </v-col>
                      <v-col cols="auto" style="width: 100px; flex: 0 0 100px;">
                        <div class="text-right text-subtitle-2">
                          {{ item.price | money(100, receipt.currency) }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>

                <!-- PDV / PNP breakdown -->
                <div
                  v-if="(receipt.pdv && receipt.pdv.length > 0) || receipt.pnp"
                  class="d-flex justify-end mt-3"
                >
                  <table class="pdv-breakdown-table">
                    <thead>
                      <tr>
                        <th></th>
                        <th>Stopa</th>
                        <th>Osnovica</th>
                        <th>Iznos</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(pdv, pi) in receipt.pdv" :key="'pdv-' + pi">
                        <td class="pdv-label">PDV</td>
                        <td>{{ pdv.rate / 100 }}%</td>
                        <td>{{ pdv.base | money(100, receipt.currency) }}</td>
                        <td>{{ pdv.total | money(100, receipt.currency) }}</td>
                      </tr>
                      <tr v-if="receipt.pnp">
                        <td class="pdv-label">PNP</td>
                        <td>{{ receipt.pnp.rate / 100 }}%</td>
                        <td>{{ receipt.pnp.base | money(100, receipt.currency) }}</td>
                        <td>{{ receipt.pnp.total | money(100, receipt.currency) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          </div>

          <!-- Pagination footer -->
          <div
            v-if="(receipts.length > 0 || hasMore) && shouldShowPagination"
            class="pagination-footer">
            <v-btn
              class="page-nav-btn-header"
              :disabled="!hasPrevPage || isLoadingReceipts"
              @click="prevPage"
              small>
              <v-icon small class="mr-1">mdi-chevron-left</v-icon>
              Prethodni
            </v-btn>
            <span class="pagination-info">Stranica {{ currentPage }}</span>
            <v-btn
              class="page-nav-btn-header"
              :disabled="!hasNextPage || isLoadingReceipts"
              @click="nextPage"
              small>
              Sljedeći
              <v-icon small class="ml-1">mdi-chevron-right</v-icon>
            </v-btn>
          </div>

          <!-- Empty state -->
          <v-card
            v-if="receipts.length === 0 && !isLoadingReceipts"
            class="receipt-card"
            flat
          >
            <v-card-text class="text-center pa-8">
              <v-icon size="64" color="grey lighten-1"
                >mdi-receipt-text-outline</v-icon
              >
              <div class="mt-4 text-h6 grey--text">Nema računa za prikaz</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <generate-receipt-from-offer ref="receiptFromOffer" />
      <generate-receipt-from-virman ref="receiptFromVirman" />
      <send-email ref="ordinaryEmail" @receiptEdit="onReceiptEdit"></send-email>
      <send-email ref="clientWarning" @receiptEdit="onReceiptEdit"></send-email>
      <pay-receipt ref="payReceipt" @receiptEdit="onPayReceiptEdit" />
      <status-to-unpaid
        ref="statusToUnpaid"
        @receiptEdit="onReceiptEdit"
      ></status-to-unpaid>
      <payment-change
        ref="paymentChanges"
        @receiptEdit="onReceiptEdit"
        @reprintReceipt="onReceiptReprint"
      ></payment-change>
      <add-tip
        ref="addTip"
        @receiptEdit="onReceiptEdit"
        @reprintReceipt="onReceiptReprint"
      ></add-tip>
    </v-container>
    <change-receipt-type-dialog
      ref="chengeReceiptTypeDialog"
    ></change-receipt-type-dialog>
    <crud-template-dialog ref="crudTemplateDialog"></crud-template-dialog>
    <edit-receipt-dialog ref="editReceiptDialog"></edit-receipt-dialog>
    <receipt-menu ref="receiptMenu" @menuClicked="onMenuClicked"></receipt-menu>

    <!-- eRačun Dialogs -->
    <document-detail-dialog
      v-model="eracunDetailDialog"
      :document="selectedEracunDocument"
    />
    <pdf-viewer-dialog
      v-model="eracunPdfDialog"
      :document-id="selectedEracunDocument ? selectedEracunDocument.id : null"
      :document-name="selectedEracunDocument ? selectedEracunDocument.documentId : 'document'"
    />
    <xml-viewer-dialog
      v-model="eracunXmlDialog"
      :document-id="selectedEracunDocument ? selectedEracunDocument.id : null"
      :document-name="selectedEracunDocument ? selectedEracunDocument.documentId : 'document'"
    />
    <e-reporting-dialog ref="eReportingDialog" />
    <status-update-dialog
      v-model="eracunStatusDialog"
      :document-id="selectedEracunDocument ? selectedEracunDocument.documentId : null"
      :issue-year="selectedEracunDocument ? selectedEracunDocument.issueYear : null"
      :current-status="selectedEracunDocument ? selectedEracunDocument.status : null"
      :document-type="'outgoing'"
      :document-amount="selectedEracunDocument ? selectedEracunDocument.amount : 0"
      @update-status="handleEracunStatusUpdate"
    />

    <!-- Top Center Fiscalize Button -->
    <v-btn
      v-if="!modal && unfiskReceipts.length > 0"
      class="top-center-fiscalize-btn"
      :loading="fiscalizing"
      @click="fiscalizeAll"
      id="fiscalizeBtn"
      elevation="8"
      rounded
      color="error"
    >
      <v-icon class="mr-2">mdi-cash-register</v-icon>
      {{ $t("$vuetify.receipts.fiscalizing") }}
      <v-chip small class="ml-2" color="white" text-color="error">
        {{ unfiskReceipts.length }}
      </v-chip>
    </v-btn>
  </div>
</template>
<script>
import axios from 'axios'
import { getFirebaseIdToken } from '@/api/token'
import rules from '@/plugins/rules'
import { df, auth, functions } from '@/plugins/firebase'
import state from '@/state'
import { v4 as uuidv4 } from 'uuid'
import flow from '@/mixins/flow'
import applicationSettings from '@/mixins/applicationSettings'
import { clone, toISOLocal } from '@/plugins/utils'
import { reprint } from '@/libs/bixolon/reprint'
import EventBus from '@/plugins/event-bus'
import { print58 } from '@/libs/bixolon/print58'
import LogData from '@/model/LogData'
import log from '@/mixins/log'
import { callAssociates } from '@/api/associates'
import eracunApi from '@/api/eracun'
import { ereportingApi } from '@/api/ereporting'

export default {
  components: {
    Confirm: () => import('@/components/Confirm.vue'),
    GenerateReceiptFromOffer: () => import('@/modules/company/components/GenerateReceiptFromOffer'),
    GenerateReceiptFromVirman: () => import('@/modules/company/components/GenerateReceiptFromVirman'),
    ChangeReceiptTypeDialog: () => import('@/modules/cash-register/components/dialogs/ChangeReceiptTypeDialog.vue'),
    PayReceipt: () => import('@/modules/company/components/PayReceipt'),
    SendEmail: () => import('@/modules/company/components/SendEmail'),
    StatusToUnpaid: () => import('@/modules/company/components/StatusToUnpaid'),
    PaymentChange: () => import('@/modules/company/components/PaymentChange'),
    AddTip: () => import('@/modules/company/components/AddTip'),
    ReceiptMenu: () => import('@/modules/cash-register/components/dialogs/ReceiptMenu.vue'),
    CrudTemplateDialog: () => import('@/modules/cash-register/components/dialogs/CrudTemplateDialog'),
    EditReceiptDialog: () => import('@/modules/cash-register/components/dialogs/EditReceiptDialog'),
    DocumentDetailDialog: () => import('@/modules/company/components/einvoices/shared/DocumentDetailDialog.vue'),
    PdfViewerDialog: () => import('@/modules/company/components/einvoices/shared/PdfViewerDialog.vue'),
    XmlViewerDialog: () => import('@/modules/company/components/einvoices/shared/XmlViewerDialog.vue'),
    EReportingDialog: () => import('@/modules/company/components/einvoices/shared/EReportingDialog.vue'),
    StatusUpdateDialog: () => import('@/modules/company/components/einvoices/shared/StatusUpdateDialog.vue')
  },
  mixins: [flow, applicationSettings, log],
  inject: [
    'showMsgBox',
    'showLoader',
    'hideLoader',
    'openPdfPrint',
    'closePdfPrint'
  ],
  data: function () {
    return {
      modal: false,
      loading: false,
      receipts: [],
      receiptsRaw: [],
      unfiskReceipts: [],
      location: {},
      locations: [],
      associates: [],
      defaultAssociates: [],
      clientSearchInput: null,
      statusFilter: {},
      oibFilter: undefined,
      oibFilterManual: undefined,
      receiptNumberFilter: '',
      paymentMethodFilter: null,
      receiptNumberParsed: null,
      filterChoosen: '',
      loadingReceipts: false,
      lastVisible: {},
      isExecuted: false,
      listeners: [],
      realTimeListener: null,
      increment: 1,
      selected: {},
      reciptOffer: {},
      multiplier: 0,
      show: false,
      fiscalizing: false,
      filtersExpanded: true,
      expandIcon: 'mdi-minus',
      rules: {
        req: rules.req(),
        oib: rules.oib(),
        email: v => !v || /.+@.+\..+/.test(v) || 'Email mora biti validan'
      },
      loadingDialog: false,
      registerIdFilter: undefined,
      locationIdFilter: undefined,
      lastBalanceTimestampFilter: undefined,
      dateFrom: null,
      dateTo: null,
      dateFromMenu: false,
      dateToMenu: false,
      showAdvanced: false,
      hideFilter: false,
      statusUpdateDialogVisible: false,
      statusUpdateReceiptId: null,
      statusUpdateReceiptAmount: 0,
      // Pagination
      currentPage: 1,
      isLoadingReceipts: false,
      hasMore: false,
      pageCache: new Map(),
      pageCursors: [],
      // Virman selection
      selectedVirmans: [],
      selectAllVirmans: false,
      virmanPaymentFilter: 'unpaid', // Default filter - samo nenaplaćeni
      // Hardcoded taxes - isti kao u CrudTemplateDialog
      taxes: [
        { name: 'PDV 25%', value: 1.25, rate: 0.25 },
        { name: 'PDV 13%', value: 1.13, rate: 0.13 },
        { name: 'PDV 5%', value: 1.05, rate: 0.05 },
        { name: 'PDV 0%', value: 1, rate: 0 }
      ],
      // eRačun dialogs
      eracunDetailDialog: false,
      eracunPdfDialog: false,
      eracunXmlDialog: false,
      eracunStatusDialog: false,
      selectedEracunDocument: null,
      paymentTypes: [],
      // eRačun email dialog
      eracunEmailDialog: false,
      eracunEmail: ''
    }
  },
  computed: {
    reciptOfferChoices () {
      return [
        { name: this.$tc('$vuetify.receipt', 2), value: 'receipts' },
        { name: this.$tc('$vuetify.offer', 2), value: 'offers' },
        { name: 'Virman', value: 'virmans' }
      ]
    },
    paymentMethods () {
      return [
        { name: 'Svi', value: null },
        { name: 'Transakcijski račun', value: 'TRANSAKCIJSKI RAČUN' },
        { name: 'Gotovina', value: 'NOVČANICE' },
        { name: 'Kartica', value: 'KARTICA' },
        { name: 'Ostalo', value: 'OSTALO' }
      ]
    },
    now () {
      return parseInt((`${new Date().getTime()}` / 1000).toFixed(0))
    },
    isValidEmail () {
      return this.eracunEmail && /.+@.+\..+/.test(this.eracunEmail)
    },
    locs: {
      get: function () {
        return this.locations
      },
      set: function (nv) {
        this.locations = [
          { name: this.$t('$vuetify.all'), id: '', location_id: '' }
        ].concat(nv)
      }
    },
    filters () {
      if (this.reciptOffer === 'receipts') {
        return [
          { name: 'Email poslan', value: 'email' },
          { name: 'Nenaplativo', value: 'uncollectible' },
          { name: 'Neplaćeni', value: 'unpayed' },
          { name: 'Nefiskalizirani', value: 'unfisc' },
          { name: 'Opomena poslana', value: 'notice' },
          { name: 'Plaćeni', value: 'payed' },
          { name: 'Povezan s predujmom', value: 'avans_deducted' },
          { name: 'Primljen predujam', value: 'avans' },
          { name: 'Svi', value: 'all' }
        ]
      } else {
        return [
          { name: 'Svi', value: 'all' }
        ]
      }
    },
    // Pagination computed properties
    itemsPerPage () {
      // Za virmane sa odabranim klijentom, prikaži sve
      if (this.reciptOffer === 'virmans' && this.oibFilter) {
        return 1000 // Veliki limit da prikaže sve virmane za klijenta
      }

      // Automatski odredi broj stavki po veličini ekrana
      if (this.$vuetify.breakpoint.xs) {
        return 5 // Mobile - manje stavki
      } else if (this.$vuetify.breakpoint.sm) {
        return 10 // Tablet
      } else if (this.$vuetify.breakpoint.md) {
        return 15 // Medium desktop
      } else {
        return 10 // Large desktop
      }
    },
    shouldShowPagination () {
      // Ne prikazuj paginaciju za virmane sa odabranim klijentom
      return !(this.reciptOffer === 'virmans' && this.oibFilter)
    },
    hasPrevPage () {
      return this.currentPage > 1
    },
    hasNextPage () {
      return this.hasMore
    },
    canCreateReceiptFromVirmans () {
      // Mora biti odabran barem 1 virman
      if (this.selectedVirmans.length < 1) return false

      // Svi virmani moraju biti istog kupca (payer_oib ili payer_name)
      const firstVirman = this.selectedVirmans[0]
      const firstPayer = firstVirman.type.payer_oib || firstVirman.type.payer_name

      return this.selectedVirmans.every(virman => {
        const payer = virman.type.payer_oib || virman.type.payer_name
        return payer === firstPayer
      })
    },
    allVisibleVirmansSelected () {
      if (this.receipts.length === 0) return false
      // Filtriraj samo nenaplaćene virmane za "Označi sve"
      const selectableVirmans = this.receipts.filter(r => !this.isVirmanPaid(r))
      if (selectableVirmans.length === 0) return false
      return selectableVirmans.every(receipt => this.isVirmanSelected(receipt))
    },
    virmanPaymentFilterOptions () {
      return [
        { name: 'Nenaplaćeni', value: 'unpaid' },
        { name: 'Naplaćeni', value: 'paid' },
        { name: 'Svi', value: 'all' }
      ]
    },
    activeAdvancedCount () {
      let count = 0
      if (this.statusFilter) count++
      if (this.oibFilter) count++
      if (this.oibFilterManual) count++
      if (this.receiptNumberFilter) count++
      if (this.paymentMethodFilter) count++
      return count
    }
  },
  watch: {
    dateFrom (val) {
      if (val) {
        const d = new Date(val)
        const endOfMonth = new Date(d.getFullYear(), d.getMonth() + 1, 0)
        this.dateTo = endOfMonth.toISOString().substr(0, 10)
      }
    },
    oibFilter (newVal, oldVal) {
      if (newVal !== oldVal) {
        // Resetuj paginaciju kada se promijeni klijent
        this.currentPage = 1
        this.lastVisible = null
        this.pageCache.clear()
        this.pageCursors = []
        // Za virmane, resetuj i selekciju
        if (this.reciptOffer === 'virmans') {
          this.clearVirmanSelection()
        }
        this.loadReceipts()
      }
    },
    virmanPaymentFilter (newVal, oldVal) {
      if (newVal !== oldVal && this.reciptOffer === 'virmans') {
        // Očisti selekciju i osvježi prikaz
        this.clearVirmanSelection()
        this.currentPage = 1
        this.pageCache.clear()
        this.pageCursors = []
        this.loadReceipts()
      }
    },
    location: {
      deep: true,
      handler (nv, ov) {
        if (nv !== ov) {
          this.currentPage = 1
          this.lastVisible = null
          this.receipts = []
          this.unfiskReceipts = []
          this.pageCache.clear()
          this.pageCursors = []
          this.loadReceipts()
        }
      }
    },
    statusFilter: {
      deep: true,
      handler (nv, ov) {
        if (nv !== ov) {
          this.currentPage = 1
          this.lastVisible = null
          this.receipts = []
          this.unfiskReceipts = []
          this.pageCache.clear()
          this.pageCursors = []
          this.loadReceipts()
        }
      }
    },
    clientSearchInput (val) {
      // Search for clients when user types 3 or more characters
      if (val && val.length >= 3) {
        this.searchAssociates(val)
      } else if (!val || val.length === 0) {
        // Reset to default associates when search is cleared
        this.associates = clone(this.defaultAssociates)
      }
    },
    reciptOffer (newVal, oldVal) {
      if (newVal !== oldVal) {
        // Očisti selekciju kada se promijeni tip dokumenta
        this.clearVirmanSelection()
      }
    }
  },
  mounted () {
    this.oibFilterManual = ''

    if (this.$attrs.receiptFilter) {
      this.oibFilterManual = this.$attrs.receiptFilter.oibFilter
      this.reciptOffer = this.$attrs.receiptFilter.reciptOffer
      this.modal = this.$attrs.receiptFilter.modal
    }

    if (this.$attrs.receiptFilter?.registerId) {
      this.registerIdFilter = this.$attrs.receiptFilter.registerId
    }
    if (this.$attrs.receiptFilter?.locationId) {
      this.locationIdFilter = this.$attrs.receiptFilter.locationId
    }
    if (this.$attrs.receiptFilter?.lastBalanceTimestamp) {
      this.lastBalanceTimestampFilter = this.$attrs.receiptFilter.lastBalanceTimestamp
    }
    if (this.$attrs.receiptFilter?.hideFilter) {
      this.hideFilter = this.$attrs.receiptFilter.hideFilter
    }

    // this.getAssociates()
    this.getMultiplier()
    this.locations = [
      { name: this.$t('$vuetify.all'), id: '', location_id: '' }
    ]
    // this.location = this.locations[0]

    // this.reciptOffer = this.reciptOfferChoices[0].value

    const docRef = df.doc(
      `user_locations/${auth.currentUser.uid}.${state.getCurrentCompany().id}`
    )
    const listener = docRef.onSnapshot(doc => {
      if (
        doc &&
        doc.data() &&
        doc.data().locations &&
        Object.keys(doc.data().locations).length > 0
      ) {
        this.locs = Object.keys(doc.data().locations).map(key => {
          return doc.data().locations[key]
        })
      }
    })
    this.listeners.push(listener)

    this.receiptNumberFilter = ''

    // Postavi default tip dokumenta na "Računi"
    if (!this.reciptOffer || Object.keys(this.reciptOffer).length === 0) {
      this.reciptOffer = 'receipts'
    }

    EventBus.$off('stopButtonLoader')
    EventBus.$on('stopButtonLoader', (data) => {
      this.loadingDialog = false
    })

    // Slušaj receiptCreated event za virman update
    EventBus.$on('receiptCreated', this.handleReceiptCreated)

    // Učitaj taxes i payment types za virman kreiranje
    this.loadTaxesAndPaymentTypes()

    // Učitaj prvu stranicu računa
    this.loadReceipts()
  },

  beforeDestroy () {
    // Cleanup real-time listener
    if (this.realTimeListener) {
      this.realTimeListener()
      this.realTimeListener = null
    }

    // Cleanup EventBus listeners
    EventBus.$off('receiptCreated', this.handleReceiptCreated)

    // Cleanup all other listeners
    this.listeners.forEach(listener => {
      if (listener) {
        listener()
      }
    })
  },

  methods: {
    formatQty (amt) {
      return (amt / this.multiplier).toLocaleString('hr-HR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatDateOnly (timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp * 1000)
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      return `${day}.${month}.${year}.`
    },
    showPaymentDueDays (paymentDue) {
      if (!paymentDue) return 'Nema datuma'

      const dueDate = new Date(paymentDue * 1000)
      const today = new Date()

      dueDate.setHours(0, 0, 0, 0)
      today.setHours(0, 0, 0, 0)

      const diffTime = dueDate - today
      const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24))

      if (diffDays > 0) {
        var days = 'dana'
        if (diffDays === 1) {
          days = 'dan'
        }
        return `${diffDays} ${days}`
      } else if (diffDays < 0) {
        return `Kasni ${Math.abs(diffDays)} dana`
      } else {
        return 'Danas'
      }
    },
    editReceipt (receipt) {
      this.loadingDialog = true
      this.showLoader()
      this.$refs.editReceiptDialog.open(this.loadingDialog, receipt)
    },
    editVirman (virman) {
      this.loadingDialog = true
      this.showLoader()
      // Otvori EditReceiptDialog sa virmanom, ali postavi entity na 'virman'
      this.$refs.editReceiptDialog.open(this.loadingDialog, virman, 'virman')
    },
    changeBalanceTimestampFilter (balanceTimestamp) {
      if (balanceTimestamp) {
        this.lastBalanceTimestampFilter = balanceTimestamp
      }
      this.applyFilter()
    },
    setReceiptType (receiptOffer) {
      this.reciptOffer = receiptOffer
    },
    printReceiptNew (receipt) {
      this.showLoader()
      var printTemplate = ''
      if (state.getCurrentCompany().print_template && state.getCurrentCompany().print_template !== '') {
        printTemplate = state.getCurrentCompany().print_template
      }

      let entity = 'racun'
      if (this.reciptOffer === 'offers') {
        entity = 'ponuda'
      }

      if (this.reciptOffer === 'virmans') {
        entity = 'virman'
      }

      var receipttemplate = functions.httpsCallable('receiptTemplate')

      var documentSubType = 'racun'
      if (state.getCurrentCompany().receipt_type && state.getCurrentCompany().receipt_type !== '') {
        documentSubType = state.getCurrentCompany().receipt_type
      }

      receipttemplate({
        template: printTemplate,
        companyId: receipt.company_details.id,
        documentId: receipt.id,
        documentType: entity,
        documentSubType: documentSubType,
        rawJson: ''
      })
        .then((result) => {
          this.hideLoader()
          if (result.data?.document !== '') {
            this.openPdfPrint(result.data?.document)
          }
        }
        )
    },
    printOtpremnica (receipt) {
      this.showLoader()
      var printTemplate = ''
      if (state.getCurrentCompany().print_template && state.getCurrentCompany().print_template !== '') {
        printTemplate = state.getCurrentCompany().print_template
      }

      let entity = 'racun'
      if (this.reciptOffer === 'offers') {
        entity = 'ponuda'
      }

      if (this.reciptOffer === 'virmans') {
        entity = 'virman'
      }

      var receipttemplate = functions.httpsCallable('receiptTemplate')

      var documentSubType = 'otpremnica'

      receipttemplate({
        template: printTemplate,
        companyId: receipt.company_details.id,
        documentId: receipt.id,
        documentType: entity,
        documentSubType: documentSubType,
        rawJson: ''
      })
        .then((result) => {
          this.hideLoader()
          if (result.data?.document !== '') {
            this.openPdfPrint(result.data?.document)
          }
        }
        )
    },
    openCrudDialog () {
      this.loadingDialog = true
      this.$refs.crudTemplateDialog.open(this.loadingDialog)
    },
    onMenuClicked (item, receipt) {
      var func = item.action
      func(receipt)
    },
    openMenu (receipt) {
      this.$refs.receiptMenu.open(receipt, 1)
    },
    onReceiptReprint (receipt) {
      reprint('Printer1', receipt, 2)
    },
    prepareLogCall () {
      var req = new LogData()

      let userId = auth.currentUser.uid
      if (state.getCashRegisterUser().id && state.getCashRegisterUser().id !== '') {
        userId = state.getCashRegisterUser().id
      }

      req.action_name = 'Ispis kopije računa'
      req.action_id = '6'
      req.user_id = userId

      this.setLog(req)
    },

    reprintReceipt (receipt) {
      if (state.getCurrentCompany().save_log) {
        this.prepareLogCall()
      }
      const printerData = state.getSelectedPrinter()
      if (printerData.id && (printerData.id === 'A4' || printerData.id === 'T58' || printerData.id === 'T80')) {
        this.printReceiptNew(receipt)
      } else {
        if (!printerData.width || printerData.width === '80') {
          reprint(printerData, receipt, 0)
        } else {
          print58(printerData, receipt, 0)
        }
      }
    },

    applyFilter () {
      // Cleanup existing real-time listener
      if (this.realTimeListener) {
        this.realTimeListener()
        this.realTimeListener = null
      }

      this.currentPage = 1
      this.lastVisible = null
      this.receipts = []
      this.unfiskReceipts = []
      this.pageCache.clear()
      this.pageCursors = []
      this.loadReceipts()
    },

    // Navigation metode
    nextPage () {
      if (this.hasNextPage) {
        // Cleanup real-time listener when leaving first page
        if (this.currentPage === 1 && this.realTimeListener) {
          this.realTimeListener()
          this.realTimeListener = null
        }

        this.currentPage++
        this.loadReceipts()
      }
    },

    prevPage () {
      if (this.hasPrevPage) {
        this.currentPage--
        // Ne resetujemo lastVisible jer koristimo pageCursors
        this.loadReceipts()
      }
    },

    changeReceiptType (receipt) {
      this.$refs.chengeReceiptTypeDialog.open(receipt)
    },

    issueBefore (issueDateTime) {
      const tmp = new Date(
        toISOLocal(
          new Date(issueDateTime * 1000)
        )
      )

      tmp.setDate(tmp.getDate() + 2)

      const before = parseInt(
        (tmp.getTime() / 1000).toFixed(0)
      )

      return before
    },
    navigateToFlow () {
      this.$router.push({
        name: 'Home',
        params: {
        }
      })
    },
    async fiscalizeAll () {
      const that = this
      try {
        this.selected = {}

        // Payload structure - mora imati data wrapper
        const payload = {
          data: {
            action: {
              operation: 'update',
              entity: 'fiscalize_bulk',
              params: {
                company_id: state.getCurrentCompany().id
              }
            }
          }
        }

        that.showLoader()
        that.$refs.confirmFiscalize.close()

        // Dohvati Firebase Auth ID token
        const token = await getFirebaseIdToken()

        // Konstruiraj URL iz environment variable
        const apiUrl = process.env.VUE_APP_API_ROOT + 'receiptapi'

        // Direktan HTTP POST poziv
        const response = await axios.post(apiUrl, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })

        // Provjeri response code
        // Firebase Callable Functions vraćaju response.data koji sadrži result
        // Direktan HTTP poziv vraća response.data direktno
        const resultData = response.data

        if (!resultData.header || !resultData.header.code || resultData.header.code !== 200) {
          throw new Error(resultData.header?.error || 'Nije uspjela fiskalizacija računa!')
        }

        // Success - reload receipts
        that.hideLoader()
        that.currentPage = 1
        that.lastVisible = null
        that.receipts = []
        that.unfiskReceipts = []
        that.pageCache.clear()
        that.loadReceipts()
      } catch (err) {
        that.hideLoader()
        that.currentPage = 1
        that.lastVisible = null
        that.receipts = []
        that.unfiskReceipts = []
        that.pageCache.clear()
        that.loadReceipts()
        that.$refs.confirmFiscalize.close()

        // Ekstrakcija error message-a
        let errorMsg = 'An error has occurred'
        if (err.response?.data?.header?.error) {
          errorMsg = err.response.data.header.error
        } else if (err.message) {
          errorMsg = err.message
        }

        that.showMsgBox({
          text: errorMsg,
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      }
    },
    getMultiplier () {
      const listener = df.doc('project_constants/config').onSnapshot(doc => {
        this.config = doc.data()
        this.multiplier = doc.data().item_amount.decimal_multiplier
      })
      this.listeners.push(listener)
    },
    async modifyItems (change) {
      if (change.type === 'added') {
        if (change.doc.data()) {
          const _document = clone(change.doc.data())
          const issueDate = new Date(_document.issue_date_time * 1000)
          const nowDate = new Date(Date.now())

          // Provjeri da li postoji eracun gdje Success === true ili false
          try {
            const eracunSnapshot = await change.doc.ref.collection('eracun').get()
            const successDocs = eracunSnapshot.docs.filter(doc => doc.data()?.Success === true)
            const errorDocs = eracunSnapshot.docs.filter(doc => doc.data()?.Success === false)
            _document.hasEracun = successDocs.length > 0
            _document.hasEracunError = errorDocs.length > 0 && successDocs.length === 0
          } catch (error) {
            console.error('Error checking eracun subcollection:', error)
            _document.hasEracun = false
          }

          switch (_document.type.flag) {
            case 'R':
            case 'R1':
            case 'R2':
            case 'BO':
              _document.receiptOptions = [
                { title: 'Preuzmi račun', action: this.printReceiptNew },
                { title: 'Preuzmi otpremnicu', action: this.printOtpremnica },
                { title: 'Ponovi ispis', action: this.reprintReceipt },
                { title: 'Preuzmi račun (staro)', action: this.printReceipt },
                { title: 'Preuzmi konz. jela i pića', action: this.printReceiptKonz },
                { title: 'Storniraj račun', action: this.stornoReceipt },
                { title: 'Pošalji račun E-mailom', action: this.sendOrdinaryEmail },
                { title: this.$t('$vuetify.formDetails.changeReceiptType'), action: this.changeReceiptType }
              ]

              if (_document.payment_method !== 'TRANSAKCIJSKI RAČUN' && _document.jir === '') {
                _document.receiptOptions = _document.receiptOptions.filter((options) =>
                  options.title !== 'Storniraj račun')
              }

              // Ukloni "Promijeni oznaku računa" za račune koji imaju eRačun
              if (_document.hasEracun) {
                _document.receiptOptions = _document.receiptOptions.filter((options) =>
                  options.title !== this.$t('$vuetify.formDetails.changeReceiptType'))
              }

              // Dodaj opciju fiskalizacije za nefiskalizirane/polufiskalizirane račune
              // (sa ZKI ali bez JIR)
              if (_document.payment_method !== 'TRANSAKCIJSKI RAČUN' && _document.fiscalize === true &&
                  _document.zki !== '' && _document.jir === '') {
                _document.receiptOptions.unshift({
                  title: 'Fiskaliziraj račun',
                  action: this.openFiscalizeConfirm
                })
              }

              // Dodaj opciju fiskalizacije za transakcijske račune bez JIR-a
              if (_document.payment_method === 'TRANSAKCIJSKI RAČUN' && !_document.jir) {
                _document.receiptOptions.unshift({
                  title: 'Fiskaliziraj račun',
                  action: this.openFiscalizeConfirmTransactional
                })
              }

              // Dodaj opciju kreiranja eRačuna za transakcijske račune bez JIR-a i bez postojećeg eRačuna
              if (_document.payment_method === 'TRANSAKCIJSKI RAČUN' && !_document.jir && !_document.hasEracun) {
                _document.receiptOptions.unshift({
                  title: 'Kreiraj eRačun',
                  action: this.openCreateEracunConfirm
                })
                _document.receiptOptions.unshift({
                  title: 'Kreiraj eizvještavanje',
                  action: this.openCreateEizvjestavanjeConfirm
                })
              }

              // Dodaj eRačun akcije za račune koji imaju kreiran eRačun
              if (_document.hasEracun) {
                _document.receiptOptions.push({
                  title: 'Prikaži detalje',
                  action: this.showEracunDetails
                })
                _document.receiptOptions.push({
                  title: 'Prikaži PDF',
                  action: this.viewEracunPdf
                })
                _document.receiptOptions.push({
                  title: 'Prikaži XML',
                  action: this.viewEracunXml
                })
                _document.receiptOptions.push({
                  title: 'eIzvještavanje',
                  action: this.showEracunReporting
                })
                _document.receiptOptions.push({
                  title: 'Označi kao naplaćen',
                  action: this.markEracunAsPaid
                })
              }

              if (_document.payment_method !== 'TRANSAKCIJSKI RAČUN' && _document.jir !== '' && this.issueBefore(_document.issue_date_time) > this.now) {
                _document.receiptOptions.push({
                  title: 'Dodaj napojnicu',
                  action: this.addTip
                })
              }

              if (
                _document.payment?.current_status !== 'PAID' &&
                _document.payment_method === 'TRANSAKCIJSKI RAČUN'
              ) {
                _document.receiptOptions.push({
                  title: 'Plati račun',
                  action: this.payReceipt
                })
                _document.receiptOptions.push({
                  title: 'Opomeni korisnika',
                  action: this.sendWarningToClient
                })
              }

              if (
                _document.payment?.current_status !== 'UNPAID' &&
                _document.payment_method === 'TRANSAKCIJSKI RAČUN'
              ) {
                _document.receiptOptions.push({
                  title: 'Prebaci status u neplaćeno',
                  action: this.statusToUnpaid
                })
              }

              if (
                _document.payment?.current_status === 'REVERSED') {
                _document.receiptOptions = _document.receiptOptions.filter((options) =>
                  options.title !== 'Storniraj račun')
              }

              if (
                _document.payment?.current_status === 'PAID' &&
                _document.payment_method !== 'TRANSAKCIJSKI RAČUN' &&
                _document.fiscalize === true && _document.jir !== '' &&
                issueDate.getFullYear() === nowDate.getFullYear() &&
                issueDate.getMonth() === nowDate.getMonth() &&
                issueDate.getDate() === nowDate.getDate()

              ) {
                _document.receiptOptions.push({
                  title: 'Promijeni način plaćanja',
                  action: this.changePayment
                })
              }

              if (_document.payment_method === 'TRANSAKCIJSKI RAČUN') {
                // Omogući promjenu računa samo ako nema ni JIR ni ZKI (nije fiskaliziran) i nema eRačun
                const isDisabled = _document.jir || _document.zki || _document.hasEracun
                _document.receiptOptions.unshift({
                  title: 'Promijeni račun',
                  action: this.editReceipt,
                  disabled: isDisabled
                })
              }

              if (_document.payment_method === 'TRANSAKCIJSKI RAČUN' && _document.payment?.current_status !== 'UNCOLLECTIBLE') {
                _document.receiptOptions.push({
                  title: 'Prebaci status u nenaplativo',
                  action: this.changeStatusToUncollectible
                })
              }

              break
            case 'STORNO':
              _document.receiptOptions = [
                { title: 'Preuzmi račun', action: this.printReceiptNew },
                { title: 'Preuzmi otpremnicu', action: this.printOtpremnica },
                { title: 'Preuzmi račun (staro)', action: this.printReceipt },
                {
                  title: 'Pošalji račun E-mailom',
                  action: this.sendOrdinaryEmail
                }
              ]
              break
            case 'P':
              _document.receiptOptions = [
                { title: 'Preuzmi ponudu', action: this.printReceiptNew },
                { title: 'Preuzmi ponudu (staro)', action: this.printReceipt },
                {
                  title: 'Promijeni ponudu',
                  action: this.editReceipt
                },
                {
                  title: 'Izradi račun iz ponude',
                  action: this.generateReceipt
                },
                {
                  title: 'Pošalji ponudu E-mailom',
                  action: this.sendEmailOffer
                }
              ]
              break
            case 'V':
              _document.receiptOptions = [
                { title: 'Preuzmi virman', action: this.printReceipt }
              ]
          }

          let rcptSeparator = '-'
          if (_document.company_details.rcpt_separator !== undefined && _document.company_details.rcpt_separator !== '') {
            rcptSeparator = _document.company_details.rcpt_separator
          }

          if (_document.designation) {
            _document.receiptNumber = `${_document.designation.number}${rcptSeparator}${_document.designation.location_id}${rcptSeparator}${_document.designation.register_number}`
            _document.receiptNumberForEmail = _document.receiptNumber
          }

          if (_document.company_details.rcpt_num_year === true && _document.payment_method === 'TRANSAKCIJSKI RAČUN') {
            var d = new Date(_document.issue_date_time * 1000)

            _document.receiptNumber += `  <b>${d.getFullYear()}</b> `
            _document.receiptNumberForEmail += `  ${d.getFullYear()}`
          }
          if (_document.issue_date_time) {
            _document.time = _document.issue_date_time.seconds
          }
          if (_document?.type?.flag !== 'BO' && _document?.type?.payer_name) {
            _document.customer = _document.type.payer_name
          } else {
            _document.customer = this.$t('$vuetify.receipts.retailCustomer')
          }

          _document.show = false

          // Client-side filter za virmane (paid, unpaid, all)
          if (this.reciptOffer === 'virmans' && this.virmanPaymentFilter !== 'all') {
            const isPaid = !!(_document.receipt_id)
            const shouldShow = this.virmanPaymentFilter === 'paid' ? isPaid : !isPaid
            if (!shouldShow) return
          }

          this.receipts.push({
            ..._document,
            ...{ [`hover-${change.doc.data().id}`]: false }
          })
          // }

          this.receipts.sort((a, b) => b.issue_date_time - a.issue_date_time) // b - a for reverse sort
          this.$forceUpdate()
        }
      }
      if (change.type === 'modified') {
        // TODO: duplicated code, make 1 fun
        this.receipts = this.receipts.map(item => {
          let ret = item
          if (item.id === change.doc.data().id) {
            const _document = clone(change.doc.data())
            const issueDate = new Date(_document.issue_date_time * 1000)
            const nowDate = new Date(Date.now())
            switch (_document.type.flag) {
              case 'R':
              case 'R1':
              case 'R2':
              case 'BO':
                _document.receiptOptions = [
                  { title: 'Preuzmi račun', action: this.printReceiptNew },
                  { title: 'Preuzmi otpremnicu', action: this.printOtpremnica },
                  { title: 'Ponovi ispis', action: this.reprintReceipt },
                  { title: 'Preuzmi račun (staro)', action: this.printReceipt },
                  { title: 'Preuzmi konz. jela i pića', action: this.printReceiptKonz },
                  { title: 'Storniraj račun', action: this.stornoReceipt },
                  {
                    title: 'Pošalji račun E-mailom',
                    action: this.sendOrdinaryEmail
                  },
                  { title: this.$t('$vuetify.formDetails.changeReceiptType'), action: this.changeReceiptType }
                ]

                // Ukloni "Promijeni oznaku računa" za račune koji imaju eRačun
                if (item.hasEracun) {
                  _document.receiptOptions = _document.receiptOptions.filter((options) =>
                    options.title !== this.$t('$vuetify.formDetails.changeReceiptType'))
                }

                if (_document.payment_method !== 'TRANSAKCIJSKI RAČUN' && _document.fiscalize === true && _document.zki !== '' &&
                  _document.jir === '') {
                  _document.receiptOptions.unshift({
                    title: 'Fiskaliziraj račun',
                    action: this.openFiscalizeConfirm
                  })
                }

                if (_document.payment_method !== 'TRANSAKCIJSKI RAČUN' && _document.jir !== '' && this.issueBefore(_document.issue_date_time) > this.now) {
                  _document.receiptOptions.push({
                    title: 'Dodaj napojnicu',
                    action: this.addTip
                  })
                }

                if (
                  _document.payment?.current_status !== 'PAID' &&
                  _document.payment_method === 'TRANSAKCIJSKI RAČUN'
                ) {
                  _document.receiptOptions.push({
                    title: 'Plati račun',
                    action: this.payReceipt
                  })
                  _document.receiptOptions.push({
                    title: 'Opomeni korisnika',
                    action: this.sendWarningToClient
                  })
                }

                if (
                  _document.payment?.current_status !== 'UNPAID' &&
                  _document.payment_method === 'TRANSAKCIJSKI RAČUN' &&
                  _document.fiscalize === true
                ) {
                  _document.receiptOptions.push({
                    title: 'Prebaci status u neplaćeno',
                    action: this.statusToUnpaid
                  })
                }

                if (
                  _document.payment?.current_status === 'PAID' &&
                  _document.payment_method === 'TRANSAKCIJSKI RAČUN' &&
                  _document.fiscalize === true
                ) {
                  _document.receiptOptions.push({
                    title: 'Prebaci status u neplaćeno',
                    action: this.statusToUnpaid
                  })
                }

                if (
                  _document.payment?.current_status === 'PAID' &&
                  _document.payment_method !== 'TRANSAKCIJSKI RAČUN' &&
                  _document.fiscalize === true && _document.jir !== '' &&
                  issueDate.getFullYear() === nowDate.getFullYear() &&
                  issueDate.getMonth() === nowDate.getMonth() &&
                  issueDate.getDate() === nowDate.getDate()

                ) {
                  _document.receiptOptions.push({
                    title: 'Promijeni način plaćanja',
                    action: this.changePayment
                  })
                }

                if (_document.payment_method === 'TRANSAKCIJSKI RAČUN') {
                  _document.receiptOptions.unshift({
                    title: 'Promijeni račun',
                    action: this.editReceipt,
                    disabled: true
                  })
                }

                if (_document.payment_method === 'TRANSAKCIJSKI RAČUN' && _document.payment?.current_status !== 'UNCOLLECTIBLE') {
                  _document.receiptOptions.push({
                    title: 'Prebaci status u nenaplativo',
                    action: this.changeStatusToUncollectible
                  })
                }

                break
              case 'STORNO':
                _document.receiptOptions = [
                  { title: 'Preuzmi račun', action: this.printReceiptNew },
                  { title: 'Preuzmi otpremnicu', action: this.printOtpremnica },
                  { title: 'Preuzmi račun (staro)', action: this.printReceipt },
                  {
                    title: 'Pošalji račun E-mailom',
                    action: this.sendOrdinaryEmail
                  }
                ]
                break
              case 'P':
                _document.receiptOptions = [
                  { title: 'Preuzmi ponudu', action: this.printReceiptNew },
                  { title: 'Preuzmi ponudu - staro', action: this.printReceipt },
                  {
                    title: 'Promijeni ponudu',
                    action: this.editReceipt
                  },
                  {
                    title: 'Izradi račun iz ponude',
                    action: this.generateReceipt
                  },
                  {
                    title: 'Pošalji ponudu E-mailom',
                    action: this.sendEmailOffer
                  }
                ]
                break
              case 'V':
                _document.receiptOptions = [
                  { title: 'Preuzmi virman', action: this.printReceipt }
                ]
            }

            let rcptSeparator = '-'
            if (_document.company_details.rcpt_separator !== undefined && _document.company_details.rcpt_separator !== '') {
              rcptSeparator = _document.company_details.rcpt_separator
            }
            if (_document.designation) {
              _document.receiptNumber = `${_document.designation.number}${rcptSeparator}${_document.designation.location_id}${rcptSeparator}${_document.designation.register_number}`
              _document.receiptNumberForEmail = _document.receiptNumber
            }

            if (_document.company_details.rcpt_num_year === true && _document.payment_method === 'TRANSAKCIJSKI RAČUN') {
              var d = new Date(_document.issue_date_time * 1000)

              _document.receiptNumber += `  <b>${d.getFullYear()}</b> `
              _document.receiptNumberForEmail += `  ${d.getFullYear()}`
            }

            if (_document.issue_date_time) {
              _document.time = _document.issue_date_time.seconds
            }
            if (_document?.type?.flag !== 'BO' && _document?.type?.payer_name) {
              _document.customer = _document.type.payer_name
            } else {
              _document.customer = this.$t('$vuetify.receipts.retailCustomer')
            }
            ret = _document
          }
          return { ...ret, ...{ [`hover-${change.doc.data().id}`]: false } }
        })
      }

      this.receipts = this.receipts.filter((document, index, self) =>
        index === self.findIndex((t) => (
          t.id === document.id
        ))
      )
    },
    // Učitavanje računa za trenutnu stranicu
    async loadReceipts () {
      this.isLoadingReceipts = true

      try {
        const where = this.location ? this.location.location_id : ''
        const whereFilter = this.statusFilter ? this.statusFilter.value : ''
        const oibFilter = this.oibFilter

        let receiptNumberParsed
        if (this.receiptNumberFilter !== '') {
          receiptNumberParsed = this.parseReceiptNumber(this.receiptNumberFilter)

          if (receiptNumberParsed.number === 0) {
            receiptNumberParsed.number = this.parseIfNumber(this.receiptNumberFilter)
          }
        }

        // Kreiraj query sa svim filterima
        let query = df
          .collection(
            `${this.reciptOffer}/${state.getCurrentCompany().id}/${this.reciptOffer}`
          )
          .orderBy('issue_date_time', 'desc')

        // Primijeni sve filtere
        if (where) {
          query = query.where('designation.location_id', '==', where)
        }

        if (whereFilter === 'unfisc') {
          query = query.where('fiscalize', '==', true).where('jir', '==', '')
        }

        if (whereFilter === 'payed') {
          query = query.where('payment.current_status', '==', 'PAID')
        }
        if (whereFilter === 'email') {
          query = query.where('payment.current_status', '==', 'EMAIL_SENT')
        }
        if (whereFilter === 'notice') {
          query = query.where('payment.current_status', '==', 'WARNING_SENT')
        }

        if (whereFilter === 'unpayed') {
          query = query.where('payment.current_status', '==', 'UNPAID')
        }

        if (whereFilter === 'avans') {
          query = query.where('tags', 'array-contains', { receipt_type: 'AVANS', tag: 'RECEIPT_TYPE' })
        }

        if (whereFilter === 'avans_deducted') {
          query = query.where('tags', 'array-contains', { receipt_type: 'AVANS_DEDUCTED', tag: 'RECEIPT_TYPE' })
        }

        if (whereFilter === 'uncollectible') {
          query = query.where('payment.current_status', '==', 'UNCOLLECTIBLE')
        }

        if (this.oibFilterManual && this.oibFilterManual.length > 0 && !isNaN(this.oibFilterManual)) {
          query = query.where('type.payer_oib', '==', this.oibFilterManual)
        }

        if (this.registerIdFilter) {
          query = query.where('designation.register_id', '==', this.registerIdFilter)
        }

        if (this.lastBalanceTimestampFilter) {
          query = query.where('issue_date_time', '>', this.lastBalanceTimestampFilter)
        }

        if (this.dateFrom) {
          query = query.where('issue_date_time', '>=', new Date(this.dateFrom).getTime() / 1000)
        }

        if (this.dateTo) {
          query = query.where('issue_date_time', '<=', new Date(this.dateTo).getTime() / 1000 + 86399)
        }

        // Payment method filter
        if (this.paymentMethodFilter) {
          query = query.where('payment_method', '==', this.paymentMethodFilter)
        }

        // Virman payment filter is applied client-side (see modifyItems + iterative fetch below)

        if (oibFilter) {
          let argument
          if (!isNaN(oibFilter)) {
            argument = oibFilter
          } else if (typeof oibFilter === 'object') {
            argument = oibFilter.oib || (oibFilter.oibs && oibFilter.oibs[0])
          } else if (typeof oibFilter === 'string') {
            argument = oibFilter
          }

          if (argument) {
            query = query.where('type.payer_oib', '==', argument)
          } else if (oibFilter && typeof oibFilter === 'object' && oibFilter.name) {
            query = query.where('type.payer_name', '==', oibFilter.name)
          }
        }

        if (receiptNumberParsed) {
          if (receiptNumberParsed.number && receiptNumberParsed.number > 0) {
            query = query.where('designation.number', '==', receiptNumberParsed.number)
          }

          if (receiptNumberParsed.register_number && receiptNumberParsed.register_number > 0) {
            query = query.where('designation.register_number', '==', receiptNumberParsed.register_number)
          }

          if (receiptNumberParsed.location_id && receiptNumberParsed.location_id !== '') {
            query = query.where('designation.location_id', '==', receiptNumberParsed.location_id)
          }
        }

        // PAGINATION
        const useIterative = this.reciptOffer === 'virmans' && this.virmanPaymentFilter !== 'all'
        let docs

        if (useIterative) {
          // Iterative fetch: keep loading batches until we have itemsPerPage matching docs
          const BATCH = Math.max(this.itemsPerPage * 4, 40)
          const needed = this.itemsPerPage + 1
          const collected = []
          let cursor = null
          if (this.currentPage > 1) {
            cursor = this.pageCursors[this.currentPage - 1] || this.lastVisible || null
          }

          while (collected.length < needed) {
            let batchQuery = query.limit(BATCH)
            if (cursor) batchQuery = batchQuery.startAfter(cursor)
            const snap = await batchQuery.get()
            if (snap.empty) break
            for (const doc of snap.docs) {
              const data = doc.data()
              const isPaid = !!(data && data.receipt_id)
              const matches = this.virmanPaymentFilter === 'paid' ? isPaid : !isPaid
              if (matches) {
                collected.push(doc)
                if (collected.length === needed) break
              }
            }
            if (snap.docs.length < BATCH) break
            cursor = snap.docs[snap.docs.length - 1]
          }

          this.hasMore = collected.length > this.itemsPerPage
          docs = collected.slice(0, this.itemsPerPage)
        } else {
          // Standard cursor-based pagination
          let receiptsQuery = query.limit(this.itemsPerPage + 1)
          if (this.currentPage > 1) {
            const cursorIndex = this.currentPage - 1
            if (this.pageCursors[cursorIndex]) {
              receiptsQuery = receiptsQuery.startAfter(this.pageCursors[cursorIndex])
            } else if (this.lastVisible) {
              receiptsQuery = receiptsQuery.startAfter(this.lastVisible)
            }
          }
          const snapshot = await receiptsQuery.get()
          this.hasMore = snapshot.docs.length > this.itemsPerPage
          docs = snapshot.docs.slice(0, this.itemsPerPage)
        }

        // Updateaj lastVisible i cursor za sljedeću stranicu
        if (docs.length > 0) {
          this.lastVisible = docs[docs.length - 1]
          if (!this.pageCursors[this.currentPage - 1]) {
            this.pageCursors[this.currentPage - 1] = docs[0]
          }
        }

        // Processiraj račune
        this.receipts = []
        docs.forEach(doc => {
          const change = { type: 'added', doc }
          this.modifyItems(change)
        })

        // Setup unfiscalized receipts listener
        this.setupUnfiscalizedListener()

        // Setup real-time listener for new receipts
        this.setupRealTimeListener()
      } catch (error) {
        console.error('Error loading receipts:', error)
        this.showMsgBox({
          text: 'Greška pri učitavanju računa',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      } finally {
        this.isLoadingReceipts = false
      }
    },

    // Setup listener za nefiskalizirane račune
    setupUnfiscalizedListener () {
      if (state.getCurrentCompany().id !== '') {
        // Clear existing unfiscalized receipts
        this.unfiskReceipts = []

        const tmp = new Date()
        tmp.setDate(tmp.getDate() - 2)

        const before = parseInt(
          (tmp.getTime() / 1000).toFixed(0)
        )

        // Query bez gornje vremenske granice - hvata sve nefiskalizirane iz zadnja 2 dana i sve buduće
        const query = df.collection(`receipts/${state.getCurrentCompany().id}/receipts`)
          .where('fiscalize', '==', true)
          .where('jir', '==', '')
          .where('issue_date_time', '>=', before)
          .orderBy('issue_date_time', 'desc')

        const listener = query
          .onSnapshot((doc) => {
            this.unfiskReceipts = []
            doc.docs.forEach((rec) => {
              this.unfiskReceipts.push(rec.data())
            })
          })
        this.listeners.push(listener)
      }
    },

    // Helper metoda za provjeru da li račun odgovara svim aktivnim filterima
    receiptMatchesFilters (receipt) {
      // Location filter
      if (this.location && this.location.location_id) {
        if (!receipt.designation || receipt.designation.location_id !== this.location.location_id) {
          return false
        }
      }

      // Status filter
      if (this.statusFilter && this.statusFilter.value) {
        const filterValue = this.statusFilter.value
        if (filterValue === 'unfisc') {
          if (!(receipt.fiscalize === true && receipt.jir === '')) {
            return false
          }
        } else if (filterValue === 'payed') {
          if (receipt.payment?.current_status !== 'PAID') {
            return false
          }
        } else if (filterValue === 'email') {
          if (receipt.payment?.current_status !== 'EMAIL_SENT') {
            return false
          }
        } else if (filterValue === 'notice') {
          if (receipt.payment?.current_status !== 'WARNING_SENT') {
            return false
          }
        } else if (filterValue === 'unpayed') {
          if (receipt.payment?.current_status !== 'UNPAID') {
            return false
          }
        } else if (filterValue === 'uncollectible') {
          if (receipt.payment?.current_status !== 'UNCOLLECTIBLE') {
            return false
          }
        }
      }

      // OIB filter
      if (this.oibFilterManual && this.oibFilterManual.length > 0 && !isNaN(this.oibFilterManual)) {
        if (receipt.type?.payer_oib !== this.oibFilterManual) {
          return false
        }
      }

      if (this.oibFilter) {
        let argument
        if (!isNaN(this.oibFilter)) {
          argument = this.oibFilter
        } else if (typeof this.oibFilter === 'object') {
          argument = this.oibFilter.oib || (this.oibFilter.oibs && this.oibFilter.oibs[0])
        } else if (typeof this.oibFilter === 'string') {
          argument = this.oibFilter
        }

        if (argument) {
          if (receipt.type?.payer_oib !== argument) return false
        } else if (typeof this.oibFilter === 'object' && this.oibFilter.name) {
          if (receipt.type?.payer_name !== this.oibFilter.name) return false
        }
      }

      // Receipt number filter
      if (this.receiptNumberFilter && this.receiptNumberFilter !== '') {
        const receiptNumberParsed = this.parseReceiptNumber(this.receiptNumberFilter)
        if (receiptNumberParsed) {
          if (receiptNumberParsed.number && receiptNumberParsed.number > 0) {
            if (receipt.designation?.number !== receiptNumberParsed.number) {
              return false
            }
          }
          if (receiptNumberParsed.register_number && receiptNumberParsed.register_number > 0) {
            if (receipt.designation?.register_number !== receiptNumberParsed.register_number) {
              return false
            }
          }
          if (receiptNumberParsed.location_id && receiptNumberParsed.location_id !== '') {
            if (receipt.designation?.location_id !== receiptNumberParsed.location_id) {
              return false
            }
          }
        }
      }

      return true
    },

    // Setup real-time listener za nove račune
    setupRealTimeListener () {
      // Cleanup existing listener
      if (this.realTimeListener) {
        this.realTimeListener()
        this.realTimeListener = null
      }

      // Samo na prvoj stranici slušamo za nove račune
      if (this.currentPage !== 1 || state.getCurrentCompany().id === '') {
        return
      }

      try {
        // Koristi trenutno vrijeme minus 30 sekundi kao buffer - hvataćemo račune kreirane od sada
        const startTime = parseInt((new Date().getTime() / 1000).toFixed(0)) - 30

        // Jednostavan query samo sa issue_date_time - ne zahtijeva composite index
        const query = df.collection(`${this.reciptOffer}/${state.getCurrentCompany().id}/${this.reciptOffer}`)
          .where('issue_date_time', '>', startTime)
          .orderBy('issue_date_time', 'desc')
          .limit(10) // Učitaj više jer ćemo filtrirati u memoriji

        // Flag za ignoriranje inicijalnog snapshota
        let isInitialSnapshot = true

        // Setup listener
        this.realTimeListener = query.onSnapshot((snapshot) => {
          // Ignoriraj prvi snapshot jer sadrži postojeće dokumente koje smo već učitali
          if (isInitialSnapshot) {
            isInitialSnapshot = false
            return
          }

          // Samo novi dokumenti nakon što je listener pokrenut
          snapshot.docChanges().forEach((change) => {
            if (change.type === 'added') {
              const newReceipt = change.doc.data()
              newReceipt.id = change.doc.id

              // Provjeri da li račun već postoji u listi
              const exists = this.receipts.some(r => r.id === newReceipt.id)

              if (!exists) {
                // Primjeni sve filtere u memoriji
                if (this.receiptMatchesFilters(newReceipt)) {
                  // Processiraj račun kroz modifyItems da dobije sve potrebne podatke
                  const changeObj = { type: 'added', doc: change.doc }
                  this.modifyItems(changeObj)

                  // Ako imamo više od itemsPerPage, makni zadnji
                  if (this.receipts.length > this.itemsPerPage) {
                    this.receipts.pop()
                  }
                }
              }
            } else if (change.type === 'modified') {
              const modifiedReceipt = change.doc.data()
              modifiedReceipt.id = change.doc.id

              // Ažuriraj račun u listi ako postoji
              const index = this.receipts.findIndex(r => r.id === modifiedReceipt.id)
              if (index !== -1) {
                // Ako virman više ne odgovara aktivnom filteru, makni ga iz liste
                if (this.reciptOffer === 'virmans' && this.virmanPaymentFilter !== 'all') {
                  const isPaid = !!(modifiedReceipt.receipt_id)
                  const shouldShow = this.virmanPaymentFilter === 'paid' ? isPaid : !isPaid
                  if (!shouldShow) {
                    this.receipts.splice(index, 1)
                    this.$forceUpdate()
                    return
                  }
                }
                // Processiraj ažurirani račun kroz modifyItems
                const changeObj = { type: 'modified', doc: change.doc }
                this.modifyItems(changeObj)

                this.$forceUpdate()
              }
            }
          })
        }, (error) => {
          console.error('Real-time listener error:', error)
        })
      } catch (error) {
        console.error('Error setting up real-time listener:', error)
      }
    },
    changeStatusToUncollectible (receipt) {
      this.confirm({
        title: 'Prebacivanje statusa u "nenaplativo"',
        message: 'Jeste li sigurni da želite prebaciti status računa u nenaplativo?',
        options: {
          toolbar: true,
          width: 500,
          confirmText: 'DA',
          cancelText: this.$t('$vuetify.close')
        }
      }).then(async (resp) => {
        if (resp) {
          this.confirmClose()
          this.showLoader()
          const paymetDate = (new Date().getTime() / 1000).toFixed(0)

          const payload = {
            action: {
              operation: 'update',
              entity: 'receipt',
              resource_id: receipt.id,
              params: {
                company_id: state.getCurrentCompany().id,
                date: parseInt(paymetDate),
                status: 'UNCOLLECTIBLE',
                status_info: 'Pretpostavka da neće nikada biti plaćeno',
                journal_number: ''
              }
            }
          }
          var receiptApi = functions.httpsCallable('receiptapi')

          receiptApi({
            action: {
              operation: 'update',
              entity: 'receipt',
              resource_id: receipt.id,
              params: payload.action.params
            }
          }).then((result) => {
            this.hideLoader()
          })
        }
      })
    },
    parseIfNumber (value) {
      if (!isNaN(value) && value.trim() !== '') {
        return parseInt(value, 10)
      }
      return value // Ako nije broj, vraća originalni string
    },
    getReceiptsOrOffers () {
      // Cleanup existing real-time listener
      if (this.realTimeListener) {
        this.realTimeListener()
        this.realTimeListener = null
      }

      this.currentPage = 1
      this.lastVisible = null
      this.receipts = []
      this.unfiskReceipts = []
      this.pageCache.clear()
      this.pageCursors = []
      this.detachListeners()
      this.loadReceipts()
    },
    stornoReceipt (receipt) {
      this.$refs.confirmStorno.open(
        '',
        `Storniraj račun ${receipt.receiptNumber}?`,
        { confirmText: 'Da', cancelText: 'Ne' }
      )
      this.selected = receipt
    },
    changePayment (receipt) {
      this.$refs.paymentChanges.open(receipt)
    },
    addTip (receipt) {
      this.$refs.addTip.open(receipt)
    },
    printReceiptKonz (receipt, preview = false) {
      const that = this
      try {
        that.showLoader()
        const reqId = uuidv4()
        // const type = receipt && receipt.type && receipt.type.flag ? receipt.type.flag : "";
        let entity = 'receipt'
        if (this.reciptOffer === 'offers') {
          entity = 'offer'
        }

        if (this.reciptOffer === 'virmans') {
          entity = 'virman'
        }

        let printSize = null
        if (['T58', 'T80', 'A4'].includes(state.getPrinter().value)) {
          printSize = state.getPrinter().value
        } else {
          printSize = 'BIXOLON80'
        }

        const payload = {
          action: {
            operation: 'get',
            entity: entity,
            resource_id: receipt.id,
            params: {
              company_id: state.getCurrentCompany().id,
              print_size: printSize,
              konzumacija: true
            }
          }
        }

        if (that.reciptOffer === 'offers') {
          payload.action.entity = 'offer'
          payload.action.params.print_size = printSize
        }

        if (that.reciptOffer === 'virmans') {
          payload.action.entity = 'virman'
          payload.action.params.print_size = printSize
        }

        df.doc(`request/${reqId}`)
          .set({
            user_id: `${auth.currentUser.uid}`,
            device_id: 'web',
            created: `${new Date().getTime()}`,
            type: 'document',
            payload: btoa(unescape(encodeURIComponent(JSON.stringify(payload))))
          })
          .then(function () { })
          .catch(function (err) {
            that.hideLoader()
            that.showMsgBox({
              text: err && err !== '' ? err : 'An error has occurred',
              actions: ['cancel'],
              cancelBtnText: 'OK',
              color: 'error'
            })
          })

        const docRef = df.doc(`response/${reqId}`)
        const unsubscribe = docRef.onSnapshot(function (doc) {
          if (that.$refs && doc.data()) {
            // this.$refs.createBusinessForm.reset()
            unsubscribe()
            if (!doc.data().body || !doc.data().body.document) {
              that.showMsgBox({
                text: that.$t('$vuetify.errors.nullReceipt'),
                actions: ['cancel'],
                cancelBtnText: that.$t('$vuetify.close'),
                color: 'error'
              })
              that.hideLoader()
              return
            }

            if (preview) {
              that.openPdfPrint(doc.data().body.document)
              that.hideLoader()
            } else {
              const linkSource = `data:application/pdf;base64,${doc.data().body.document
                }`
              const downloadLink = document.createElement('a')
              const fileName = `${receipt.receiptNumber}.pdf`
              downloadLink.href = linkSource
              downloadLink.download = fileName
              downloadLink.click()
              that.hideLoader()
            }
          }
        })
      } catch (err) {
        that.hideLoader()
        this.showMsgBox({
          text: err && err !== '' ? err : 'An error has occurred',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      }
    },
    printReceipt (receipt, preview = false) {
      const that = this
      try {
        that.showLoader()
        const reqId = uuidv4()
        // const type = receipt && receipt.type && receipt.type.flag ? receipt.type.flag : "";
        let entity = 'receipt'
        if (this.reciptOffer === 'offers') {
          entity = 'offer'
        }

        if (this.reciptOffer === 'virmans') {
          entity = 'virman'
        }

        const payload = {
          action: {
            operation: 'get',
            entity: entity,
            resource_id: receipt.id,
            params: {
              company_id: state.getCurrentCompany().id,
              print_size: 'A4'
            }
          }
        }

        if (that.reciptOffer === 'offers') {
          payload.action.entity = 'offer'
          payload.action.params.print_size = 'A4'
        }

        if (that.reciptOffer === 'virmans') {
          payload.action.entity = 'virman'
          payload.action.params.print_size = 'A4'
        }

        df.doc(`request/${reqId}`)
          .set({
            user_id: `${auth.currentUser.uid}`,
            device_id: 'web',
            created: `${new Date().getTime()}`,
            type: 'document',
            payload: btoa(unescape(encodeURIComponent(JSON.stringify(payload))))
          })
          .then(function () { })
          .catch(function (err) {
            that.hideLoader()
            that.showMsgBox({
              text: err && err !== '' ? err : 'An error has occurred',
              actions: ['cancel'],
              cancelBtnText: 'OK',
              color: 'error'
            })
          })

        const docRef = df.doc(`response/${reqId}`)
        const unsubscribe = docRef.onSnapshot(function (doc) {
          if (that.$refs && doc.data()) {
            // this.$refs.createBusinessForm.reset()
            unsubscribe()
            if (!doc.data().body || !doc.data().body.document) {
              that.showMsgBox({
                text: that.$t('$vuetify.errors.nullReceipt'),
                actions: ['cancel'],
                cancelBtnText: that.$t('$vuetify.close'),
                color: 'error'
              })
              that.hideLoader()
              return
            }

            if (preview) {
              that.openPdfPrint(doc.data().body.document)
              that.hideLoader()
            } else {
              const linkSource = `data:application/pdf;base64,${doc.data().body.document
                }`
              const downloadLink = document.createElement('a')
              const fileName = `${receipt.receiptNumber}.pdf`
              downloadLink.href = linkSource
              downloadLink.download = fileName
              downloadLink.click()
              that.hideLoader()
            }
          }
        })
      } catch (err) {
        that.hideLoader()
        this.showMsgBox({
          text: err && err !== '' ? err : 'An error has occurred',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      }
    },
    cancelReceipt () {
      const that = this
      try {
        const receipt = Object.assign({}, this.selected)
        this.selected = {}
        const reqId = uuidv4()

        let receiptNumber = receipt.designation ? receipt.designation.number : 0
        df.doc(`cash_registers/${receipt.designation.register_id}`)
          .get()
          .then(reg => {
            if (reg && reg.exists) {
              if (reg.data()) {
                if (reg.data().status !== 'OK') {
                  this.$refs.confirmStorno.close()
                  that.showMsgBox({
                    text: that.$t('$vuetify.errors.unknownRegister'),
                    actions: ['cancel'],
                    cancelBtnText: that.$t('$vuetify.close'),
                    color: 'error'
                  })
                  return
                }
                if (this.reciptOffer === 'receipts') {
                  receiptNumber = reg.data().bill_sequence || 0
                } else if (this.reciptOffer === 'offers') {
                  receiptNumber = reg.data().offer_sequence || 0
                }
                const params = {
                  company_id: state.getCurrentCompany().id,
                  location_id: receipt.location_details.id,
                  receipt_id: receipt.id,
                  register_id: receipt.designation.register_id,
                  issue_date_time: parseInt(
                    (new Date().getTime() / 1000).toFixed(0)
                  ),
                  number: receiptNumber + 1,
                  reqid: reqId
                  // seller_id: auth.currentUser.uid,
                }

                that.showLoader()
                that.$refs.confirmStorno.close()

                const receiptApi = functions.httpsCallable('receiptapi')
                receiptApi({
                  action: {
                    operation: 'set',
                    entity: 'storno',
                    params: params
                  }
                })
                  .then(function (response) {
                    that.hideLoader()

                    // Provjeri da li je response uspješan
                    const result = response && response.data ? response.data : response
                    const code = result.code || result.header?.code

                    if (code && code !== 200) {
                      // Greška u storniranju - prikaži error
                      let errorMsg = 'Greška prilikom storniranja računa.'

                      try {
                        let rawError = result.error || result.header?.error || result.message || ''

                        if (rawError) {
                          // Ukloni XML dio
                          rawError = rawError.split('\\u003c?xml')[0].split('<xml')[0].split('<?xml')[0]

                          // Parsiranje ugnježđenih JSON stringova
                          let parsedError = rawError

                          // Ukloni "Greška u računu:" prefix
                          if (parsedError.includes('Greška u računu:')) {
                            parsedError = parsedError.split('Greška u računu:')[1].trim()
                          }

                          // Ukloni "Fiscalization failed:" ili "Receipt validation failed:" prefix
                          if (parsedError.includes('Fiscalization failed:') || parsedError.includes('Receipt validation failed:')) {
                            const splitMarker = parsedError.includes('Fiscalization failed:') ? 'Fiscalization failed:' : 'Receipt validation failed:'
                            const parts = parsedError.split(splitMarker)
                            if (parts[1]) {
                              parsedError = parts[1].trim()
                            }
                          }

                          // Pokušaj iterativno parsirati ugnježđeni JSON - idi najdublje što možeš
                          let attempts = 0
                          let lastSuccessfulParse = parsedError

                          while (attempts < 10) {
                            attempts++
                            try {
                              // Prvo dekoduj escape karaktere prije parsiranja
                              const toParse = parsedError
                                .replace(/\\"/g, '"')
                                .replace(/\\n/g, '\n')
                                .replace(/\\r/g, '\r')
                                .replace(/\\\\/g, '\\')

                              if (toParse.startsWith('{') || toParse.startsWith('[')) {
                                const parsed = JSON.parse(toParse)

                                if (typeof parsed === 'string') {
                                  // Nastavi parsiranje stringa
                                  lastSuccessfulParse = parsed
                                  parsedError = parsed
                                } else if (parsed.message) {
                                  // Uzmi message field i nastavi
                                  lastSuccessfulParse = parsed.message
                                  parsedError = parsed.message
                                } else {
                                  // Nema više message fieldova
                                  break
                                }
                              } else {
                                // Nije JSON, ovo je finalni string
                                break
                              }
                            } catch (e) {
                              // Parsiranje failed, koristi zadnji uspješni parse
                              parsedError = lastSuccessfulParse
                              break
                            }
                          }

                          errorMsg = parsedError
                            .replace(/\\n/g, '\n')
                            .replace(/\\r/g, '\r')
                            .replace(/\\"/g, '"')
                            .replace(/\\\\/g, '\\')
                            .trim()

                          // Ukloni vodeće/trailing navodne znakove
                          if (errorMsg.startsWith('"') && errorMsg.endsWith('"')) {
                            errorMsg = errorMsg.slice(1, -1)
                          }
                        }
                      } catch (e) {
                        console.error('Error parsing storno error:', e)
                      }

                      that.showMsgBox({
                        text: errorMsg,
                        actions: ['cancel'],
                        cancelBtnText: 'OK',
                        color: 'error'
                      })
                      // Ne return-aj - neka se refresha lista i nakon greške
                    }

                    // Refreshaj listu (čak i nakon greške)
                    that.currentPage = 1
                    that.lastVisible = null
                    that.receipts = []
                    that.unfiskReceipts = []
                    that.pageCache.clear()
                    that.loadReceipts()
                  })
                  .catch(function (err) {
                    that.hideLoader()
                    that.showMsgBox({
                      text: err && err.message ? err.message : 'An error has occurred',
                      actions: ['cancel'],
                      cancelBtnText: 'OK',
                      color: 'error'
                    })
                  })
              }
            } else {
              that.showMsgBox({
                text: that.$t('$vuetify.errors.unknownRegister'),
                actions: ['cancel'],
                cancelBtnText: that.$t('$vuetify.close'),
                color: 'error'
              })
              that.hideLoader()
              this.$refs.confirmStorno.close()
            }
          })
      } catch (err) {
        this.$refs.confirmStorno.close()
        that.hideLoader()
        that.showMsgBox({
          text: err || 'An error has occurred',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      }
    },
    generateReceipt (receipt) {
      if (receipt && receipt.type && receipt.type.flag && receipt.type.flag === 'V') {
        this.$refs.receiptFromVirman.open(receipt, this.multiplier)
      } else if (receipt && receipt.type && receipt.type.flag && receipt.type.flag === 'P') {
        // Ponude sada koriste CrudTemplateDialog
        this.createReceiptFromOffer(receipt)
      } else {
        // Fallback za ostale tipove
        this.$refs.receiptFromOffer.open(receipt, this.multiplier)
      }
    },
    payReceipt (receipt) {
      this.$refs.payReceipt.open(receipt)
    },
    onPayReceiptEdit (receipt) {
      this.onReceiptEdit(receipt)
      if (receipt.hasEracun) {
        this.$nextTick(() => this.markEracunAsPaid(receipt))
      }
    },
    onReceiptEdit (receipt) {
      // If status is EMAIL_SENT or WARNING_SENT, update directly without polling
      if (receipt.payment?.current_status === 'EMAIL_SENT' || receipt.payment?.current_status === 'WARNING_SENT') {
        this.receipts = this.receipts.map(r => {
          if (r.id === receipt.id) {
            return {
              ...r,
              payment: {
                ...r.payment,
                current_status: receipt.payment.current_status
              }
            }
          }
          return r
        })
        return
      }

      // For other operations, set to PROCESSING and poll for status
      this.receipts = this.receipts.map(r => {
        if (r.id === receipt.id) {
          r.payment.current_status = 'PROCESSING'
        }
        return r
      })

      // Pokreni polling da provjeravas status dok se ne promijeni iz PROCESSING
      this.pollReceiptStatus(receipt.id)
    },
    async pollReceiptStatus (receiptId, maxAttempts = 20, interval = 1500) {
      let attempts = 0

      const refreshSingle = async () => {
        const snap = await df.doc(`receipts/${state.getCurrentCompany().id}/receipts/${receiptId}`).get()
        if (snap.exists) {
          const updated = snap.data()
          const idx = this.receipts.findIndex(r => r.id === receiptId)
          if (idx > -1) {
            this.$set(this.receipts, idx, { ...this.receipts[idx], ...updated })
          }
        }
      }

      const checkStatus = async () => {
        attempts++

        await refreshSingle()

        const receipt = this.receipts.find(r => r.id === receiptId)

        if (!receipt || !receipt.payment) return

        if (receipt.payment.current_status !== 'PROCESSING') return

        if (attempts < maxAttempts) {
          setTimeout(checkStatus, interval)
        } else {
          await refreshSingle()
        }
      }

      setTimeout(checkStatus, interval)
    },
    sendOrdinaryEmail (receipt) {
      this.$refs.ordinaryEmail.open(receipt, {
        action: 'EMAIL_SENT',
        title: 'Pošalji račun mailom',
        okBtn: 'Pošalji EMail'
      })
    },
    sendEmailOffer (receipt) {
      this.$refs.ordinaryEmail.open(receipt, {
        action: 'OFFER_SENT',
        title: 'Pošalji ponudu mailom',
        okBtn: 'Pošalji EMail'
      })
    },
    sendWarningToClient (receipt) {
      this.$refs.clientWarning.open(receipt, {
        action: 'WARNING_SENT',
        title: 'Opomeni korisnika',
        okBtn: 'Opomeni'
      })
    },
    statusToUnpaid (receipt) {
      this.$refs.statusToUnpaid.open(receipt)
    },
    openFiscalizeConfirm (receipt) {
      this.$refs.confirmFiscalize.open(
        '',
        `Fiskaliziraj račun ${receipt.receiptNumber}?`,
        { confirmText: 'Da', cancelText: 'Ne' }
      )
      this.selected = receipt
    },
    openFiscalizeConfirmTransactional (receipt) {
      this.$refs.confirmFiscalize.open(
        '',
        `Fiskaliziraj transakcijski račun ${receipt.receiptNumber}?`,
        { confirmText: 'Da', cancelText: 'Ne' }
      )
      this.selected = receipt
      this.selected.isTransactional = true
    },
    fiscalizeReceipt () {
      // Provjeri da li je transakcijski račun
      if (this.selected && this.selected.isTransactional) {
        this.fiscalizeTransactionalReceipt()
        return
      }

      const that = this
      try {
        const receipt = Object.assign({}, this.selected)
        this.selected = {}
        const reqId = uuidv4()

        const payload = {
          action: {
            operation: 'update',
            entity: 'fiscalize',
            resource_id: receipt.id,
            params: {
              company_id: state.getCurrentCompany().id
            }
          }
        }

        that.showLoader()
        that.$refs.confirmFiscalize.close()
        df.doc(`request/${reqId}`)
          .set({
            user_id: `${auth.currentUser.uid}`,
            device_id: 'web',
            created: `${new Date().getTime()}`,
            type: 'receipt',
            payload: btoa(
              unescape(encodeURIComponent(JSON.stringify(payload)))
            )
          })
          .then(function () {
          })
          .catch(function (err) {
            that.hideLoader()
            that.currentPage = 1
            that.lastVisible = null
            that.receipts = []
            that.unfiskReceipts = []
            that.pageCache.clear()
            that.loadReceipts()
            that.$refs.confirmFiscalize.close()
            that.showMsgBox({
              text: err && err !== '' ? err : 'An error has occurred',
              actions: ['cancel'],
              cancelBtnText: 'OK',
              color: 'error'
            })
          })

        const docRef = df.doc(`response/${reqId}`)
        const unsubscribe = docRef.onSnapshot(function (doc) {
          if (that.$refs && doc.data()) {
            unsubscribe()
            if (!doc.data().header || !doc.data().header.code || doc.data().header.code !== 200) {
              that.showMsgBox({
                text: doc.data().header.error ? doc.data().header.error : 'Nije uspjela fiskalizacija računa!',
                actions: ['cancel'],
                cancelBtnText: that.$t('$vuetify.close'),
                color: 'error'
              })
              that.hideLoader()
              that.currentPage = 1
              that.lastVisible = null
              that.receipts = []
              that.unfiskReceipts = []
              that.pageCache.clear()
              that.loadReceipts()
              that.$refs.confirmFiscalize.close()
              return
            }

            that.hideLoader()
            that.currentPage = 1
            that.lastVisible = null
            that.receipts = []
            that.unfiskReceipts = []
            that.pageCache.clear()
            that.loadReceipts()
            that.$refs.confirmFiscalize.close()
          }
        })
      } catch (err) {
        that.hideLoader()

        that.currentPage = 1
        that.lastVisible = null
        that.receipts = []
        that.unfiskReceipts = []
        that.pageCache.clear()
        that.loadReceipts()
        that.$refs.confirmFiscalize.close()
        that.showMsgBox({
          text: err || 'An error has occurred',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      }
    },

    fiscalizeTransactionalReceipt () {
      const that = this
      try {
        const receipt = Object.assign({}, this.selected)
        this.selected = {}

        that.showLoader()
        that.$refs.confirmFiscalize.close()

        // Direktan poziv receiptApi
        const receiptApi = functions.httpsCallable('receiptapi')

        receiptApi({
          action: {
            operation: 'update',
            entity: 'post_process_receipt',
            resource_id: receipt.id,
            params: {
              company_id: state.getCurrentCompany().id,
              fiscalize: true
            }
          }
        })
          .then(function (result) {
            that.hideLoader()

            if (!result || !result.data || result.data.code !== 200) {
              const errorMsg = result?.data?.error || result?.header?.error || 'Nije uspjela fiskalizacija računa!'
              that.showMsgBox({
                text: errorMsg,
                actions: ['cancel'],
                cancelBtnText: that.$t('$vuetify.close'),
                color: 'error'
              })
              that.currentPage = 1
              that.lastVisible = null
              that.receipts = []
              that.unfiskReceipts = []
              that.pageCache.clear()
              that.loadReceipts()
              return
            }

            // Uspješna fiskalizacija - prikaži JIR i ZKI
            if (result.data && result.data.fiscalized) {
              const successMsg = `Račun je uspješno fiskaliziran!\n\nJIR: ${result.data.jir || 'N/A'}\nZKI: ${result.data.zki || 'N/A'}`
              that.showMsgBox({
                text: successMsg,
                actions: ['cancel'],
                cancelBtnText: 'U redu',
                color: 'success'
              })
            }

            that.currentPage = 1
            that.lastVisible = null
            that.receipts = []
            that.unfiskReceipts = []
            that.pageCache.clear()
            that.loadReceipts()
          })
          .catch(function (err) {
            that.hideLoader()
            that.currentPage = 1
            that.lastVisible = null
            that.receipts = []
            that.unfiskReceipts = []
            that.pageCache.clear()
            that.loadReceipts()
            that.showMsgBox({
              text: err.message || err || 'Došlo je do greške pri fiskalizaciji',
              actions: ['cancel'],
              cancelBtnText: 'OK',
              color: 'error'
            })
          })
      } catch (err) {
        that.hideLoader()
        that.currentPage = 1
        that.lastVisible = null
        that.receipts = []
        that.unfiskReceipts = []
        that.pageCache.clear()
        that.loadReceipts()
        that.$refs.confirmFiscalize.close()
        that.showMsgBox({
          text: err.message || err || 'Došlo je do greške pri fiskalizaciji',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      }
    },

    openCreateEracunConfirm (receipt) {
      this.$refs.confirmCreateEracun.open(
        '',
        `Kreirati eRačun za transakcijski račun ${receipt.receiptNumber}?`,
        { confirmText: 'Da', cancelText: 'Ne' }
      )
      this.selected = receipt
    },

    openCreateEizvjestavanjeConfirm (receipt) {
      this.$refs.confirmCreateEizvjestavanje.open(
        '',
        `Kreirati eizvještavanje za transakcijski račun ${receipt.receiptNumber}?`,
        { confirmText: 'Da', cancelText: 'Ne' }
      )
      this.selected = receipt
    },

    async openEracunEmailDialog () {
      // Zatvori confirm dialog
      this.$refs.confirmCreateEracun.close()

      // Resetuj email
      this.eracunEmail = ''

      // Pokušaj automatski popuniti email iz associate-a
      await this.fetchAssociateEmail()

      // Otvori email dialog
      this.eracunEmailDialog = true
    },

    async fetchAssociateEmail () {
      // Provjeri da li postoji OIB kupca
      const oib = this.selected?.type?.payer_oib
      if (!oib || oib.length < 3) {
        return
      }

      try {
        // Pozovi associates API sa OIB-om
        const searchPath = `/associates/${state.getCurrentCompany().id}/associate?limit=20&filter=trigram(eq:${encodeURIComponent(oib)})`
        const response = await callAssociates('get', searchPath)

        if (response && response.status === 200 && response.data && response.data.associates) {
          // Pronađi prvog associate-a koji ima email
          const associates = Object.values(response.data.associates)
          const associateWithEmail = associates.find(assoc => assoc.email && assoc.status === 'OK')

          if (associateWithEmail && associateWithEmail.email) {
            this.eracunEmail = associateWithEmail.email
          }
        }
      } catch (error) {
        console.error('Error fetching associate email:', error)
        // Ne prikazuj error korisniku, samo ostavi email prazan
      }
    },

    closeEracunEmailDialog () {
      this.eracunEmailDialog = false
      this.eracunEmail = ''
      this.selected = {}
    },

    createEracunWithEmail () {
      if (!this.isValidEmail) {
        return
      }
      this.eracunEmailDialog = false
      this.createEracun()
    },

    createEracun () {
      const that = this
      try {
        const receipt = Object.assign({}, this.selected)
        this.selected = {}

        that.showLoader()
        that.$refs.confirmCreateEracun.close()

        // Direktan poziv receiptApi
        const receiptApi = functions.httpsCallable('receiptapi')

        receiptApi({
          action: {
            operation: 'update',
            entity: 'post_process_receipt',
            resource_id: receipt.id,
            params: {
              company_id: state.getCurrentCompany().id,
              eracun: true,
              eracun_email: that.eracunEmail
            }
          }
        })
          .then(function (result) {
            that.hideLoader()

            // Provjera da li je API poziv uspješan (HTTP 200)
            if (!result || !result.data || result.data.code !== 200) {
              const errorMsg = result?.data?.error || result?.header?.error || 'Nije uspjelo kreiranje eRačuna!'
              that.showMsgBox({
                text: errorMsg,
                actions: ['cancel'],
                cancelBtnText: that.$t('$vuetify.close'),
                color: 'error'
              })
              that.currentPage = 1
              that.lastVisible = null
              that.receipts = []
              that.unfiskReceipts = []
              that.pageCache.clear()
              that.loadReceipts()
              return
            }

            // Provjera da li je kreiranje eRačuna uspješno (status/success)
            if (result.data.status === 'error' || result.data.success === false) {
              // Parse message ako je JSON string
              let errorMsg = result.data.message || 'Greška pri kreiranju eRačuna'
              try {
                const parsedMsg = JSON.parse(errorMsg)
                if (parsedMsg.message) {
                  errorMsg = parsedMsg.message
                }
              } catch (e) {
                // Message nije JSON, koristi direktno
              }

              that.showMsgBox({
                text: errorMsg,
                actions: ['cancel'],
                cancelBtnText: that.$t('$vuetify.close'),
                color: 'error'
              })
              that.currentPage = 1
              that.lastVisible = null
              that.receipts = []
              that.unfiskReceipts = []
              that.pageCache.clear()
              that.loadReceipts()
              return
            }

            // Uspješno kreiranje eRačuna
            const successMsg = result.data.message || 'eRačun je uspješno kreiran!'
            that.showMsgBox({
              text: successMsg,
              actions: ['cancel'],
              cancelBtnText: 'U redu',
              color: 'success'
            })

            that.currentPage = 1
            that.lastVisible = null
            that.receipts = []
            that.unfiskReceipts = []
            that.pageCache.clear()
            that.loadReceipts()
          })
          .catch(function (err) {
            that.hideLoader()
            that.currentPage = 1
            that.lastVisible = null
            that.receipts = []
            that.unfiskReceipts = []
            that.pageCache.clear()
            that.loadReceipts()
            that.showMsgBox({
              text: err.message || err || 'Došlo je do greške pri kreiranju eRačuna',
              actions: ['cancel'],
              cancelBtnText: 'OK',
              color: 'error'
            })
          })
      } catch (err) {
        that.hideLoader()
        that.currentPage = 1
        that.lastVisible = null
        that.receipts = []
        that.unfiskReceipts = []
        that.pageCache.clear()
        that.loadReceipts()
        that.$refs.confirmCreateEracun.close()
        that.showMsgBox({
          text: err.message || err || 'Došlo je do greške pri kreiranju eRačuna',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      }
    },

    createEizvjestavanje () {
      const that = this
      try {
        const receipt = Object.assign({}, this.selected)
        this.selected = {}

        that.showLoader()
        that.$refs.confirmCreateEizvjestavanje.close()

        // Direktan poziv receiptApi
        const receiptApi = functions.httpsCallable('receiptapi')

        receiptApi({
          action: {
            operation: 'update',
            entity: 'post_process_receipt',
            resource_id: receipt.id,
            params: {
              company_id: state.getCurrentCompany().id,
              eizvjestavanje: true
            }
          }
        })
          .then(function (result) {
            that.hideLoader()

            // Provjera da li je API poziv uspješan (HTTP 200)
            if (!result || !result.data || result.data.code !== 200) {
              const errorMsg = result?.data?.error || result?.header?.error || 'Nije uspjelo kreiranje eizvještavanja!'
              that.showMsgBox({
                text: errorMsg,
                actions: ['cancel'],
                cancelBtnText: that.$t('$vuetify.close'),
                color: 'error'
              })
              that.currentPage = 1
              that.lastVisible = null
              that.receipts = []
              that.unfiskReceipts = []
              that.pageCache.clear()
              that.loadReceipts()
              return
            }

            // Provjera da li je kreiranje eizvještavanja uspješno (status/success)
            if (result.data.status === 'error' || result.data.success === false) {
              // Parse message ako je JSON string
              let errorMsg = result.data.message || 'Greška pri kreiranju eizvještavanja'
              try {
                const parsedMsg = JSON.parse(errorMsg)
                if (parsedMsg.message) {
                  errorMsg = parsedMsg.message
                }
              } catch (e) {
                // Message nije JSON, koristi direktno
              }

              that.showMsgBox({
                text: errorMsg,
                actions: ['cancel'],
                cancelBtnText: that.$t('$vuetify.close'),
                color: 'error'
              })
              that.currentPage = 1
              that.lastVisible = null
              that.receipts = []
              that.unfiskReceipts = []
              that.pageCache.clear()
              that.loadReceipts()
              return
            }

            // Uspješno kreiranje eizvještavanja
            const successMsg = result.data.message || 'eizvještavanje je uspješno kreirano!'
            that.showMsgBox({
              text: successMsg,
              actions: ['cancel'],
              cancelBtnText: 'U redu',
              color: 'success'
            })

            that.currentPage = 1
            that.lastVisible = null
            that.receipts = []
            that.unfiskReceipts = []
            that.pageCache.clear()
            that.loadReceipts()
          })
          .catch(function (err) {
            that.hideLoader()
            that.currentPage = 1
            that.lastVisible = null
            that.receipts = []
            that.unfiskReceipts = []
            that.pageCache.clear()
            that.loadReceipts()
            that.showMsgBox({
              text: err.message || err || 'Došlo je do greške pri kreiranju eizvještavanja',
              actions: ['cancel'],
              cancelBtnText: 'OK',
              color: 'error'
            })
          })
      } catch (err) {
        that.hideLoader()
        that.currentPage = 1
        that.lastVisible = null
        that.receipts = []
        that.unfiskReceipts = []
        that.pageCache.clear()
        that.loadReceipts()
        that.$refs.confirmCreateEizvjestavanje.close()
        that.showMsgBox({
          text: err.message || err || 'Došlo je do greške pri kreiranju eizvještavanja',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      }
    },

    // eRačun akcije
    async showEracunDetails (receipt) {
      try {
        this.showLoader()
        const companyId = state.getCurrentCompany().id

        // Dohvati Response.ID iz eracun podkolekcije (kao za PDF/XML)
        const eracunSnapshot = await df.doc(`receipts/${companyId}/receipts/${receipt.id}`)
          .collection('eracun')
          .get()

        // Filtriraj samo dokumente gdje marker.success nije false
        const successDocs = eracunSnapshot.docs.filter(doc => {
          const markerSuccess = doc.data()?.marker?.success
          return markerSuccess !== false
        })

        if (successDocs.length > 0) {
          const eracunDoc = successDocs[0]
          const eracunData = eracunDoc.data()
          const eracunId = eracunData?.Response?.ID || eracunDoc.id

          console.log('📄 Loading eRačun details with ID from subcollection:', eracunId, 'companyId:', companyId)

          // Učitaj detalje eRačuna putem API-ja sa Response.ID kao path parametar
          const document = await eracunApi.getDocument(eracunId, companyId)

          console.log('📄 Received eRačun document data:', document)

          // Osiguraj da dokument ima sve potrebne podatke za prikaz u dijalogu
          if (!document.companyId) {
            document.companyId = companyId
          }

          this.selectedEracunDocument = document
          this.eracunDetailDialog = true
        } else {
          this.showMsgBox({
            text: 'eRačun nije pronađen u podkolekciji',
            actions: ['cancel'],
            cancelBtnText: 'OK',
            color: 'error'
          })
        }

        this.hideLoader()
      } catch (error) {
        this.hideLoader()
        console.error('Error loading eRačun details:', error)
        const errorMessage = error.parsedMessage || error.response?.data?.message || 'Greška pri učitavanju eRačuna'
        this.showMsgBox({
          text: errorMessage,
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      }
    },

    async viewEracunPdf (receipt) {
      try {
        this.showLoader()
        const companyId = state.getCurrentCompany().id

        // Dohvati Response.ID iz eracun podkolekcije
        const eracunSnapshot = await df.doc(`receipts/${companyId}/receipts/${receipt.id}`)
          .collection('eracun')
          .get()

        // Filtriraj samo dokumente gdje marker.success nije false
        const successDocs = eracunSnapshot.docs.filter(doc => {
          const markerSuccess = doc.data()?.marker?.success
          return markerSuccess !== false
        })

        if (successDocs.length > 0) {
          const eracunDoc = successDocs[0]
          const eracunData = eracunDoc.data()
          const eracunId = eracunData?.Response?.ID || eracunDoc.id

          console.log('📄 Loading eRačun PDF with ID from subcollection:', eracunId, 'companyId:', companyId)

          // Postavi selectedEracunDocument sa ID-jem iz podkolekcije
          this.selectedEracunDocument = {
            id: eracunId,
            documentId: `${receipt.designation.number}-${receipt.designation.location_id}-${receipt.designation.register_number}`
          }
          this.eracunPdfDialog = true
        } else {
          this.showMsgBox({
            text: 'eRačun nije pronađen u podkolekciji',
            actions: ['cancel'],
            cancelBtnText: 'OK',
            color: 'error'
          })
        }

        this.hideLoader()
      } catch (error) {
        this.hideLoader()
        console.error('Error loading eRačun PDF:', error)
        const errorMessage = error.parsedMessage || error.response?.data?.message || 'Greška pri učitavanju PDF-a'
        this.showMsgBox({
          text: errorMessage,
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      }
    },

    async viewEracunXml (receipt) {
      try {
        this.showLoader()
        const companyId = state.getCurrentCompany().id

        // Dohvati Response.ID iz eracun podkolekcije
        const eracunSnapshot = await df.doc(`receipts/${companyId}/receipts/${receipt.id}`)
          .collection('eracun')
          .get()

        // Filtriraj samo dokumente gdje marker.success nije false
        const successDocs = eracunSnapshot.docs.filter(doc => {
          const markerSuccess = doc.data()?.marker?.success
          return markerSuccess !== false
        })

        if (successDocs.length > 0) {
          const eracunDoc = successDocs[0]
          const eracunData = eracunDoc.data()
          const eracunId = eracunData?.Response?.ID || eracunDoc.id

          console.log('📄 Loading eRačun XML with ID from subcollection:', eracunId, 'companyId:', companyId)

          // Postavi selectedEracunDocument sa ID-jem iz podkolekcije
          this.selectedEracunDocument = {
            id: eracunId,
            documentId: `${receipt.designation.number}-${receipt.designation.location_id}-${receipt.designation.register_number}`
          }
          this.eracunXmlDialog = true
        } else {
          this.showMsgBox({
            text: 'eRačun nije pronađen u podkolekciji',
            actions: ['cancel'],
            cancelBtnText: 'OK',
            color: 'error'
          })
        }

        this.hideLoader()
      } catch (error) {
        this.hideLoader()
        console.error('Error loading eRačun XML:', error)
        const errorMessage = error.parsedMessage || error.response?.data?.message || 'Greška pri učitavanju XML-a'
        this.showMsgBox({
          text: errorMessage,
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      }
    },

    async showEracunReporting (receipt) {
      try {
        this.showLoader()
        const companyId = state.getCurrentCompany().id

        // Konstruiraj documentId iz designation
        const documentId = `${receipt.designation.number}-${receipt.designation.location_id}-${receipt.designation.register_number}`

        // Izvuci issueYear iz receipt.issue_date_time (UNIX timestamp u sekundama)
        const issueDate = new Date(receipt.issue_date_time * 1000).toISOString()

        console.log('📄 Opening eReporting dialog with documentId:', documentId, 'issueDate:', issueDate, 'companyId:', companyId)

        // Kreiraj document objekt sa potrebnim poljima za EReportingDialog
        const document = {
          documentId: documentId,
          issueDate: issueDate, // EReportingDialog expects issueDate or dateTimeIssued
          companyId: companyId
        }

        this.$refs.eReportingDialog.show(document)

        this.hideLoader()
      } catch (error) {
        this.hideLoader()
        console.error('Error opening eReporting dialog:', error)
        const errorMessage = error.parsedMessage || error.response?.data?.message || 'Greška pri otvaranju eReporting dialoga'
        this.showMsgBox({
          text: errorMessage,
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      }
    },

    async markEracunAsPaid (receipt) {
      try {
        this.showLoader()
        const companyId = state.getCurrentCompany().id

        // Konstruiraj documentId iz designation
        const documentId = `${receipt.designation.number}-${receipt.designation.location_id}-${receipt.designation.register_number}`

        // Izvuci issueYear iz receipt.issue_date_time
        const issueYear = new Date(receipt.issue_date_time * 1000).getFullYear()

        // Iznos računa u eurima (receipt.total je u centima)
        const amount = receipt.total ? receipt.total / 100 : 0

        // Dohvati Response.ID iz eracun podkolekcije (potreban za API poziv)
        const eracunSnapshot = await df.doc(`receipts/${companyId}/receipts/${receipt.id}`)
          .collection('eracun')
          .get()

        // Filtriraj samo dokumente gdje marker.success nije false
        const successDocs = eracunSnapshot.docs.filter(doc => {
          const markerSuccess = doc.data()?.marker?.success
          return markerSuccess !== false
        })

        if (successDocs.length > 0) {
          const eracunDoc = successDocs[0]
          const eracunData = eracunDoc.data()
          const eracunId = eracunData?.Response?.ID || eracunDoc.id

          console.log('📄 Opening eReporting dialog for marking as paid:', {
            eracunId,
            documentId,
            issueYear,
            amount
          })

          // Postavi selectedEracunDocument sa svim podacima potrebnim za dialog i API poziv
          this.selectedEracunDocument = {
            id: eracunId, // Response.ID iz podkolekcije - koristi se za API endpoint /paid/{id}
            documentId: documentId, // Broj računa - šalje se u payloadu
            issueYear: issueYear,
            issueDate: new Date(receipt.issue_date_time * 1000).toISOString().split('T')[0], // Format YYYY-MM-DD
            status: 5, // Status 5 = Označi kao naplaćen
            amount: amount, // Iznos računa u eurima (automatski popunjen u modalu)
            supplierPartyId: companyId, // ID tvrtke
            receiptId: receipt.id // Originalni receipt ID za osvježavanje
          }

          // Otvori status dialog - korisnik će unijeti podatke i tek onda se šalje API poziv
          this.eracunStatusDialog = true
        } else {
          this.showMsgBox({
            text: 'eRačun nije pronađen u podkolekciji',
            actions: ['cancel'],
            cancelBtnText: 'OK',
            color: 'error'
          })
        }

        this.hideLoader()
      } catch (error) {
        this.hideLoader()
        console.error('Error loading eRačun data:', error)
        this.showMsgBox({
          text: 'Greška pri učitavanju podataka eRačuna',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      }
    },

    async handleEracunStatusUpdate ({ documentId, issueYear, payload, updateMask }) {
      try {
        this.showLoader()
        const companyId = state.getCurrentCompany().id

        // Za status 5 (Označi kao naplaćen) koristi eReporting API
        if (payload.status === 5 && payload.paidAmount && payload.paymentType) {
          // Dohvati Response.ID iz selectedEracunDocument (već učitano u markEracunAsPaid)
          const eracunId = this.selectedEracunDocument?.id
          const issueDate = this.selectedEracunDocument?.issueDate

          if (!eracunId) {
            throw new Error('Response.ID nije pronađen u selectedEracunDocument')
          }

          console.log('📄 Marking eRačun as paid via eReporting API:', {
            eracunId,
            documentId,
            issueDate,
            paidAmount: payload.paidAmount,
            paymentType: payload.paymentType,
            paymentDate: payload.paymentDate
          })

          // Kreiraj payload za eReporting API prema formatu iz curl poziva
          const ereportingPayload = {
            id: String(eracunId), // Mora biti string
            documentId: String(documentId), // Mora biti string
            issueDate: issueDate,
            paidAmount: parseFloat(payload.paidAmount), // Mora biti number
            paymentDate: payload.paymentDate,
            paymentType: parseInt(payload.paymentType), // Mora biti number
            customerPartyId: '', // Prazan string kao u curl primjeru
            supplierPartyId: this.selectedEracunDocument?.supplierPartyId || companyId
          }

          // Dodaj opis ako postoji
          if (payload.note) {
            ereportingPayload.description = payload.note
          }

          // Koristi markAsPaidById koji poziva /reports/paid/{id}
          await ereportingApi.markAsPaidById(eracunId, ereportingPayload)

          this.showMsgBox({
            text: 'eRačun je uspješno označen kao naplaćen',
            actions: ['cancel'],
            cancelBtnText: 'OK',
            color: 'success'
          })
        } else {
          // Za sve ostale statusne promjene koristi eRacun API
          console.log('📄 Updating eRačun status:', {
            documentId,
            issueYear,
            status: payload.status
          })

          await eracunApi.updateDocumentStatusByDocumentId(documentId, issueYear, payload, companyId, updateMask)

          this.showMsgBox({
            text: 'Status eRačuna je uspješno ažuriran',
            actions: ['cancel'],
            cancelBtnText: 'OK',
            color: 'success'
          })
        }

        this.eracunStatusDialog = false
        const receiptId = this.selectedEracunDocument?.receiptId
        if (receiptId) {
          const snap = await df.doc(`receipts/${state.getCurrentCompany().id}/receipts/${receiptId}`).get()
          if (snap.exists) {
            const idx = this.receipts.findIndex(r => r.id === receiptId)
            if (idx > -1) this.$set(this.receipts, idx, { ...this.receipts[idx], ...snap.data() })
          }
        }
        this.hideLoader()
      } catch (error) {
        this.hideLoader()
        console.error('Error updating eRačun status:', error)
        const errorMessage = error.parsedMessage || error.response?.data?.message || 'Greška pri ažuriranju statusa eRačuna'
        this.showMsgBox({
          text: errorMessage,
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      }
    },

    onExpandFilters () {
      this.filtersExpanded = !this.filtersExpanded
      this.expandIcon = this.filtersExpanded ? 'mdi-minus' : 'mdi-plus'
    },

    parseReceiptNumber (receiptNumber) {
      receiptNumber = receiptNumber.replaceAll('/', '-')
      const parts = receiptNumber.split('-')
      if (parts.length !== 3) {
        return {
          number: 0,
          location_id: '',
          register_number: 0
        }
      }
      return { number: parseInt(parts[0]), location_id: parts[1], register_number: parseInt(parts[2]) }
    },

    async getAssociates () {
      var path = `/associates/${state.getCurrentCompany().id}/associate`
      var response = await callAssociates('get', path)

      if (response && response.status === 200 && response.data && response.data.associates) {
        this.defaultAssociates = Object.keys(response.data.associates)
          .map((key) => {
            return response.data.associates[key]
          })
          .filter((associate) => associate.status === 'OK' && associate.associate_type.BUYER)

        this.associates = clone(this.defaultAssociates)
      } else if (response.status === 404) {
        this.associates = []
        // Klijenti nisu pronađeni - tiho nastavi bez obavijesti
      } else {
        this.showMsgBox({
          text: 'Neuspjelo dohvaćanje klijenata',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
      }
    },

    async searchAssociates (searchTerm) {
      if (!searchTerm || searchTerm.length < 3) return

      try {
        const oib = this.oibFilter && typeof this.oibFilter === 'object'
          ? (this.oibFilter.oib || (this.oibFilter.oibs && this.oibFilter.oibs[0]))
          : null
        const term = oib || searchTerm.split(',')[0].trim()
        const searchPath = `/associates/${state.getCurrentCompany().id}/associate?filter=trigram(eq:${encodeURIComponent(term)})`
        const response = await callAssociates('get', searchPath)

        if (response && response.status === 200 && response.data && response.data.associates) {
          this.associates = Object.keys(response.data.associates)
            .map((key) => {
              return response.data.associates[key]
            })
            .filter((associate) => associate.status === 'OK' && associate.associate_type.BUYER)
        } else if (response.status === 404) {
          this.associates = []
        }
      } catch (error) {
        console.error('Error searching associates:', error)
        // Keep current associates on error
      }
    },

    resetField (field) {
      field === 'oib' ? this.oibFilterManual = '' : this.oibFilter = undefined
      this.applyFilter()
    },

    // ============= VIRMAN SELECTION METHODS =============

    toggleVirmanSelection (virman) {
      const index = this.selectedVirmans.findIndex(v => v.id === virman.id)

      if (index > -1) {
        // Već je odabran - ukloni ga
        this.selectedVirmans.splice(index, 1)
      } else {
        // Nije odabran - dodaj ga
        this.selectedVirmans.push(virman)
      }

      // Ažuriraj selectAll checkbox
      this.selectAllVirmans = this.allVisibleVirmansSelected
    },

    isVirmanSelected (virman) {
      return this.selectedVirmans.some(v => v.id === virman.id)
    },

    isVirmanPaid (virman) {
      // Virman je naplaćen ako ima receipt_id
      return !!(virman && virman.receipt_id)
    },

    toggleSelectAllVirmans () {
      if (this.selectAllVirmans) {
        // Dodaj sve vidljive virmane (osim naplaćenih)
        this.receipts.forEach(receipt => {
          if (!this.isVirmanSelected(receipt) && !this.isVirmanPaid(receipt)) {
            this.selectedVirmans.push(receipt)
          }
        })
      } else {
        // Očisti sve
        this.clearVirmanSelection()
      }
    },

    clearVirmanSelection () {
      this.selectedVirmans = []
      this.selectAllVirmans = false
    },

    async loadTaxesAndPaymentTypes () {
      try {
        // Učitaj payment types iz Firestore (taxes su hardcoded u data())
        const configDoc = await df.doc('project_constants/config').get()
        if (configDoc.exists) {
          const data = configDoc.data()
          this.paymentTypes = data.payment_types || []
        } else {
          console.error('Config document does not exist!')
        }
      } catch (error) {
        console.error('Error loading payment types:', error)
      }
    },

    findTaxByRate (rate) {
      // Pronađi tax objekat iz this.taxes niza
      if (!this.taxes || this.taxes.length === 0) {
        console.warn('findTaxByRate: taxes not available')
        return null
      }

      // Rate iz virmana je množen sa 100 (npr. 2500 za 25%)
      // Rate u this.taxes je 0-1 (npr. 0.25 za 25%)
      // Konvertuj virman rate (2500) -> 0.25
      const normalizedRate = rate / 10000

      const foundTax = this.taxes.find(tax => Math.abs(tax.rate - normalizedRate) < 0.001)

      if (!foundTax) {
        console.warn(`findTaxByRate: No tax found for rate ${rate} (normalized: ${normalizedRate})`)
      }

      return foundTax || null
    },

    findPaymentType (typeValue) {
      // Pronađi payment type iz this.paymentTypes niza
      // 'T' = Transakcijski račun
      if (!this.paymentTypes || this.paymentTypes.length === 0) return null

      return this.paymentTypes.find(pt => pt.value === typeValue) || null
    },

    async createReceiptFromMultipleVirmans () {
      if (!this.canCreateReceiptFromVirmans) {
        this.showMsgBox({
          text: 'Svi odabrani virmani moraju biti istog kupca.',
          actions: ['cancel'],
          cancelBtnText: 'U redu',
          color: 'warning'
        })
        return
      }

      // Učitaj payment types ako nisu učitani (taxes su hardcoded u data())
      if (!this.paymentTypes || this.paymentTypes.length === 0) {
        await this.loadTaxesAndPaymentTypes()
      }

      try {
        // Korak 1: Uzmi podatke iz prvog virmana (kupac, lokacija, valuta)
        const firstVirman = this.selectedVirmans[0]

        // Korak 2: Agregriraj sve artikle iz svih virmana
        const aggregatedItems = []
        this.selectedVirmans.forEach(virman => {
          virman.items.forEach(item => {
            // Provjeri da li artikl sa istim ID-om već postoji
            const existingItem = aggregatedItems.find(i => i.id === item.id && i.single_item_price === item.single_item_price)

            if (existingItem) {
              // Ako postoji, dodaj količinu
              existingItem.amt += item.amt
              existingItem.price += item.price
            } else {
              // Ako ne postoji, dodaj novi artikl
              aggregatedItems.push({ ...item })
            }
          })
        })

        // Korak 3: Generiraj napomenu sa popisom svih virmana
        const virmanNumbers = this.selectedVirmans.map(v =>
          `${v.designation.number}-${v.designation.location_id}-${v.designation.register_number}`
        )

        const notePrefix = this.selectedVirmans.length === 1
          ? 'Račun izrađen po virmanu'
          : 'Račun izrađen po virmanima'

        const note = `${notePrefix}: ${virmanNumbers.join(', ')}`

        // Korak 3b: Dohvati kpdcode za sve artikle iz cjenika
        // location_details.id je puni Firestore document ID lokacije (koristi se u location_pricelist)
        // designation.location_id je kratki kod (npr. "LOC1") — ne može se direktno koristiti kao path
        const designationLocId = firstVirman.designation.location_id
        const pricelistId = firstVirman.location_details?.id ||
          (this.locations.find(l => l.location_id === designationLocId)?.id) ||
          designationLocId
        const companyId = state.getCurrentCompany().id
        const kpdcodeMap = {}
        const uniqueBaseIds = [...new Set(aggregatedItems.map(i => i.id ? i.id.split('.')[0] : null).filter(Boolean))]
        await Promise.all(uniqueBaseIds.map(async (baseId) => {
          try {
            const snap = await df.doc(`location_pricelist/${pricelistId}/items/${baseId}`).get()
            if (snap.exists && snap.data().kpdcode) {
              kpdcodeMap[baseId] = snap.data().kpdcode
            } else {
              // Fallback: KPD backend writes to both location_pricelist and companies/{id}/items
              const companySnap = await df.doc(`companies/${companyId}/items/${baseId}`).get()
              if (companySnap.exists && companySnap.data().kpdcode) {
                kpdcodeMap[baseId] = companySnap.data().kpdcode
              }
            }
          } catch (e) {
            // kpdcode ostaje prazan za ovaj artikl
          }
        }))

        // Korak 4: Pripremi cart za CrudTemplateDialog
        const currency = firstVirman.currency || 'EUR'

        const cart = aggregatedItems.map(item => {
          // Odredi jedinicu mjere - koristi postojeću ili default 'kom'
          const unitName = item.measurement_unit || item.storage_unit || 'kom'
          const tax = this.findTaxByRate(item.pdv.rate)

          // Izračunaj cijene (item.single_item_price je sa PDV-om, množeno sa 100)
          const priceWithVat = item.single_item_price // Cijena SA PDV-om (množeno sa 100)
          const taxRate = item.pdv.rate / 10000 // Konvertuj 2500 -> 0.25
          const priceBase = Math.round(priceWithVat / (1 + taxRate)) // Bazna cijena BEZ PDV-a

          // Kreiraj prices objekat za sve valute (templatePayment očekuje sve 3)
          const prices = {
            EUR: { price: 0, base: 0, taxes: [] },
            USD: { price: 0, base: 0, taxes: [] },
            GBP: { price: 0, base: 0, taxes: [] }
          }

          // Postavi cijene za currency iz virmana
          prices[currency] = {
            price: priceWithVat, // Cijena SA PDV-om
            base: priceBase, // Cijena BEZ PDV-a
            taxes: [
              {
                name: tax ? tax.name : 'PDV',
                rate: item.pdv.rate, // Rate množen sa 100 (2500)
                value: tax ? tax.value : 1.25
              }
            ]
          }

          if (!tax) {
            console.warn(`Item "${item.name}" - tax not found for rate ${item.pdv.rate}`)
          }

          // Pripremi discount podatke
          const discountRate = item.discount ? (item.discount.rate / 100 || 0) : 0 // Postotak (npr. 10 za 10%)
          const hasDiscount = discountRate > 0

          // Izračunaj discounted_price ako postoji popust (u eurima)
          const discountedPrice = hasDiscount
            ? priceWithVat / 100 - (priceWithVat / 100 * discountRate / 100)
            : 0

          // Kreiraj osnovnu strukturu data objekta
          const dataObj = {
            name: item.name,
            type: 'GOODS', // Default tip
            id: item.id,
            freeItem: true,
            prices: prices
          }

          // Dodaj kompletan discount objekt ako postoji popust
          if (hasDiscount) {
            const discountAmountInCents = Math.round(priceWithVat - discountedPrice * 100)
            dataObj.discount = {
              active: true,
              amount: discountAmountInCents,
              name: 'Popust',
              rate: Math.round(discountRate * 100), // Rate u 0.01% (npr. 1000 za 10%)
              type: 'RATE'
            }
            dataObj.discounted_price = discountedPrice // U eurima
            dataObj.single_item_price = priceWithVat // U centima
          }

          return {
            data: dataObj,
            tax: tax, // Tax objekat
            unit: { storageUnit: unitName }, // Ispravna struktura sa storageUnit
            units: [{ storageUnit: unitName }], // Niz dostupnih jedinica
            unitsAndPrices: [], // Prazan niz za unitsAndPrices
            quantity: item.amt / this.multiplier, // Konvertuj u pravu količinu
            price: priceWithVat / 100, // Cijena u eurima (za prikaz)
            pricePdv: priceWithVat, // Cijena sa PDV-om (za templatePayment)
            priceBase: priceBase, // Bazna cijena (za templatePayment)
            discount: discountRate,
            discountAmt: discountRate, // Za CrudTemplateDialog
            kpdcode: kpdcodeMap[item.id ? item.id.split('.')[0] : ''] || '',
            taxCategory: null,
            taxExemptionReason: null,
            formattedQuantity: (item.amt / this.multiplier).toFixed(2), // SA TOČKOM za type="number"
            formattedPrice: (priceWithVat / 100).toFixed(2), // SA TOČKOM za type="number"
            formattedDiscount: discountRate.toFixed(2) // SA TOČKOM za type="number"
          }
        })

        // Korak 5: Pripremi customer podatke
        const customerData = {
          associateByName: firstVirman.type.payer_name,
          associateByOib: firstVirman.type.payer_oib,
          associateAddress: firstVirman.type.payer_address,
          associateZip: firstVirman.type.payer_zip_code,
          associateCity: firstVirman.type.payer_city,
          associateCountry: firstVirman.type.payer_country
        }

        // Korak 6: Pripremi datume
        const now = Date.now()
        const deliveryDate = now
        const valueDate = firstVirman.currency === 'EUR'
          ? now + (8 * 24 * 60 * 60 * 1000) // +8 dana za EUR
          : now + (30 * 24 * 60 * 60 * 1000) // +30 dana za ostale

        // Korak 7: Nađi payment type (Transakcijski račun)
        const paymentType = this.findPaymentType('T') // Helper metoda

        // Korak 8: Kreiraj initialState objekat
        const initialState = {
          cart: cart,
          ...customerData,
          paymentType: paymentType,
          currency: firstVirman.currency,
          selectedCurrency: firstVirman.currency,
          invoiceDate: now,
          valueDate: valueDate,
          deliveryDate: deliveryDate,
          note: note,
          selectedLanguage: { name: 'Hrvatski', value: 'hr' },
          pnb: '',
          pnbModel: '',
          pnbType: 0,
          selectedCustomerType: 'legal',
          wholeSaleRcptType: firstVirman.wholesale_receipt_type || '',
          selectedItems: cart.map(c => ({
            data: {
              name: c.data.name,
              id: c.data.id,
              searchName: ''
            }
          })),
          searchKeywords: cart.map(() => ''),
          comboboxes: cart.map(() => ({ disabled: false })),
          // NOVI: Metadata za virman tracking
          sourceMetadata: {
            source: 'VIRMANS_BULK', // Identifikator da je iz više virmana
            virmanIds: this.selectedVirmans.map(v => v.id), // Niz virman ID-ova
            virmanNumbers: virmanNumbers // Niz virman brojeva za referencu
          }
        }

        // Korak 9: Otvori CrudTemplateDialog sa podacima
        this.loadingDialog = true
        this.$refs.crudTemplateDialog.open(this.loadingDialog, undefined, initialState)

        // Korak 10: Očisti selekciju
        this.clearVirmanSelection()
      } catch (error) {
        console.error('Error creating receipt from virmans:', error)
        this.showMsgBox({
          text: 'Došlo je do greške prilikom kreiranja računa.',
          actions: ['cancel'],
          cancelBtnText: 'U redu',
          color: 'error'
        })
      }
    },

    async createReceiptFromOffer (offer) {
      if (!offer) {
        this.showMsgBox({
          text: 'Ponuda nije odabrana.',
          actions: ['cancel'],
          cancelBtnText: 'U redu',
          color: 'warning'
        })
        return
      }

      // Učitaj payment types ako nisu učitani
      if (!this.paymentTypes || this.paymentTypes.length === 0) {
        await this.loadTaxesAndPaymentTypes()
      }

      try {
        // Korak 1: Uzmi artikle iz ponude (bez agregiranja - samo jedna ponuda)
        const items = offer.items || []

        // Korak 2: Generiraj napomenu
        const offerNumber = `${offer.designation.number}-${offer.designation.location_id}-${offer.designation.register_number}`
        const note = `Račun izrađen po ponudi: ${offerNumber}${offer.note ? '\r\n\r\n' + offer.note : ''}`

        // Korak 2b: Dohvati kpdcode za sve artikle iz cjenika
        const offerDesignationLocId = offer.designation.location_id
        const offerPricelistId = offer.location_details?.id ||
          (this.locations.find(l => l.location_id === offerDesignationLocId)?.id) ||
          offerDesignationLocId
        const offerCompanyId = state.getCurrentCompany().id
        const offerKpdcodeMap = {}
        const uniqueOfferBaseIds = [...new Set(items.map(i => i.id ? i.id.split('.')[0] : null).filter(Boolean))]
        await Promise.all(uniqueOfferBaseIds.map(async (baseId) => {
          try {
            const snap = await df.doc(`location_pricelist/${offerPricelistId}/items/${baseId}`).get()
            if (snap.exists && snap.data().kpdcode) {
              offerKpdcodeMap[baseId] = snap.data().kpdcode
            } else {
              const companySnap = await df.doc(`companies/${offerCompanyId}/items/${baseId}`).get()
              if (companySnap.exists && companySnap.data().kpdcode) {
                offerKpdcodeMap[baseId] = companySnap.data().kpdcode
              }
            }
          } catch (e) {
            // kpdcode ostaje prazan za ovaj artikl
          }
        }))

        // Korak 3: Pripremi cart za CrudTemplateDialog
        const currency = offer.currency || 'EUR'

        const cart = items.map(item => {
          // Odredi jedinicu mjere - koristi postojeću ili default 'kom'
          const unitName = item.measurement_unit || item.storage_unit || 'kom'
          const tax = this.findTaxByRate(item.pdv.rate)

          // Izračunaj cijene (item.single_item_price je sa PDV-om, množeno sa 100)
          const priceWithVat = item.single_item_price // Cijena SA PDV-om (množeno sa 100)
          const taxRate = item.pdv.rate / 10000 // Konvertuj 2500 -> 0.25
          const priceBase = Math.round(priceWithVat / (1 + taxRate)) // Bazna cijena BEZ PDV-a

          // Kreiraj prices objekat za sve valute (templatePayment očekuje sve 3)
          const prices = {
            EUR: { price: 0, base: 0, taxes: [] },
            USD: { price: 0, base: 0, taxes: [] },
            GBP: { price: 0, base: 0, taxes: [] }
          }

          // Postavi cijene za currency iz ponude
          prices[currency] = {
            price: priceWithVat, // Cijena SA PDV-om
            base: priceBase, // Cijena BEZ PDV-a
            taxes: [
              {
                name: tax ? tax.name : 'PDV',
                rate: item.pdv.rate, // Rate množen sa 100 (2500)
                value: tax ? tax.value : 1.25
              }
            ]
          }

          if (!tax) {
            console.warn(`Item "${item.name}" - tax not found for rate ${item.pdv.rate}`)
          }

          // Pripremi discount podatke
          const discountRate = item.discount ? (item.discount.rate / 100 || 0) : 0 // Postotak (npr. 10 za 10%)
          const hasDiscount = discountRate > 0

          // Izračunaj discounted_price ako postoji popust (u eurima)
          const discountedPrice = hasDiscount
            ? priceWithVat / 100 - (priceWithVat / 100 * discountRate / 100)
            : 0

          // Kreiraj osnovnu strukturu data objekta
          const dataObj = {
            name: item.name,
            type: 'GOODS',
            id: item.id,
            freeItem: true,
            prices: prices
          }

          // Dodaj kompletan discount objekt ako postoji popust
          if (hasDiscount) {
            const discountAmountInCents = Math.round(priceWithVat - discountedPrice * 100)
            dataObj.discount = {
              active: true,
              amount: discountAmountInCents,
              name: 'Popust',
              rate: Math.round(discountRate * 100), // Rate u 0.01% (npr. 1000 za 10%)
              type: 'RATE'
            }
            dataObj.discounted_price = discountedPrice // U eurima
            dataObj.single_item_price = priceWithVat // U centima
          }

          return {
            data: dataObj,
            tax: tax,
            unit: { storageUnit: unitName },
            units: [{ storageUnit: unitName }],
            unitsAndPrices: [],
            quantity: item.amt / this.multiplier,
            price: priceWithVat / 100,
            pricePdv: priceWithVat,
            priceBase: priceBase,
            discount: discountRate,
            discountAmt: discountRate,
            kpdcode: offerKpdcodeMap[item.id ? item.id.split('.')[0] : ''] || '',
            taxCategory: null,
            taxExemptionReason: null,
            formattedQuantity: (item.amt / this.multiplier).toFixed(2),
            formattedPrice: (priceWithVat / 100).toFixed(2),
            formattedDiscount: discountRate.toFixed(2)
          }
        })

        // Korak 4: Pripremi customer podatke
        const customerData = {
          associateByName: offer.type.payer_name,
          associateByOib: offer.type.payer_oib,
          associateAddress: offer.type.payer_address,
          associateZip: offer.type.payer_zip_code,
          associateCity: offer.type.payer_city,
          associateCountry: offer.type.payer_country
        }

        // Korak 5: Pripremi datume
        const now = Date.now()
        const deliveryDate = now
        const valueDate = offer.currency === 'EUR'
          ? now + (8 * 24 * 60 * 60 * 1000) // +8 dana za EUR
          : now + (30 * 24 * 60 * 60 * 1000) // +30 dana za ostale

        // Korak 6: Nađi payment type (Transakcijski račun)
        const paymentType = this.findPaymentType('T')

        // Korak 7: Kreiraj initialState objekat
        const initialState = {
          cart: cart,
          ...customerData,
          paymentType: paymentType,
          currency: offer.currency,
          selectedCurrency: offer.currency,
          invoiceDate: now,
          valueDate: valueDate,
          deliveryDate: deliveryDate,
          note: note,
          selectedLanguage: { name: 'Hrvatski', value: 'hr' },
          pnb: '',
          pnbModel: '',
          pnbType: 0,
          selectedCustomerType: 'legal',
          wholeSaleRcptType: offer.wholesale_receipt_type || '',
          selectedItems: cart.map(c => ({
            data: {
              name: c.data.name,
              id: c.data.id,
              searchName: ''
            }
          })),
          searchKeywords: cart.map(() => ''),
          comboboxes: cart.map(() => ({ disabled: false })),
          // Metadata za offer tracking
          sourceMetadata: {
            source: 'OFFER',
            offerId: offer.id,
            offerNumber: offerNumber
          }
        }

        // Korak 8: Otvori CrudTemplateDialog sa podacima
        this.loadingDialog = true
        this.$refs.crudTemplateDialog.open(this.loadingDialog, undefined, initialState)
      } catch (error) {
        console.error('Error creating receipt from offer:', error)
        this.showMsgBox({
          text: 'Došlo je do greške prilikom kreiranja računa.',
          actions: ['cancel'],
          cancelBtnText: 'U redu',
          color: 'error'
        })
      }
    },

    async updateVirmanWithReceipt (virmanId, receiptNumber, receiptId) {
      try {
        const companyId = state.getCurrentCompany().id
        const virmanRef = df.doc(`virmans/${companyId}/virmans/${virmanId}`)

        // Timestamp
        const timestamp = Date.now()

        // 1. Ažuriraj virman dokument - dodaj flag da je račun izdan
        await virmanRef.update({
          receipt_issued: true,
          receipt_number: receiptNumber,
          receipt_id: receiptId,
          receipt_issued_at: timestamp,
          updated_at: timestamp
        })

        // 2. Kreiraj history zapis u podkolekciji
        const historyRef = virmanRef.collection('history').doc()
        await historyRef.set({
          action: 'RECEIPT_ISSUED',
          receipt_number: receiptNumber,
          receipt_id: receiptId,
          timestamp: timestamp,
          user_id: auth.currentUser.uid,
          user_name: state.getUser()?.name || 'Unknown',
          note: `Račun ${receiptNumber} izdan iz virmana`
        })
      } catch (error) {
        console.error(`Error updating virman ${virmanId}:`, error)
        // Ne blokiraj proces ako update faila
      }
    },

    async handleReceiptCreated (data) {
      // Ako je račun kreiran iz virmana
      if (data.sourceMetadata?.source === 'VIRMANS_BULK') {
        const { receiptNumber, receiptId, sourceMetadata } = data

        // Ažuriraj sve virmane
        const updatePromises = sourceMetadata.virmanIds.map(virmanId =>
          this.updateVirmanWithReceipt(virmanId, receiptNumber, receiptId)
        )

        try {
          await Promise.all(updatePromises)

          this.showMsgBox({
            text: `Račun ${receiptNumber} uspješno kreiran i povezan sa ${sourceMetadata.virmanIds.length} virmana.`,
            actions: ['cancel'],
            cancelBtnText: 'U redu',
            color: 'success'
          })

          // Osvježi prikaz virmana
          this.loadReceipts()
        } catch (error) {
          console.error('Error updating virmans:', error)
          // Ne prikazuj error korisniku jer je račun već kreiran
        }
      }
    }
  }
}
</script>
<style scoped>
/* Virman Selection Toolbar */
.virman-selection-toolbar {
  background-color: transparent;
  border-radius: 8px;
  margin: 0 0 12px 0 !important;
  padding: 6px 16px !important;
  align-items: center !important;
}

.virman-selection-toolbar >>> .v-input__slot {
  background: #ffffff !important;
  box-shadow: none !important;
  border: 1.5px solid #CFD8DC !important;
  border-radius: 6px !important;
}

.virman-selection-toolbar >>> .v-text-field.v-text-field--solo .v-input__control {
  min-height: 36px !important;
}

.virman-selection-toolbar .v-btn {
  text-transform: none;
}

.virman-selection-toolbar >>> .v-input--checkbox {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

/* Virman status mini-pill */
.virman-status-pill {
  font-size: 10px !important;
  height: 18px !important;
  padding: 0 6px !important;
}

tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.15);
}

tr:hover {
  cursor: pointer;
}

/* Glass Filter Button */
.glass-filter-btn {
  background: linear-gradient(
    135deg,
    rgba(0, 179, 190, 0.9) 0%,
    rgba(57, 137, 201, 0.85) 50%,
    rgba(97, 84, 164, 0.9) 100%
  ) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 4px 12px rgba(0, 179, 190, 0.25) !important;
  backdrop-filter: blur(10px) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.glass-filter-btn:hover {
  background: linear-gradient(
    135deg,
    rgba(0, 179, 190, 1) 0%,
    rgba(57, 137, 201, 0.95) 50%,
    rgba(97, 84, 164, 1) 100%
  ) !important;
  transform: scale(1.1);
  box-shadow: 0 8px 20px rgba(0, 179, 190, 0.4) !important;
}

.glass-filter-btn .v-icon {
  color: white !important;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

/* Glass Fiscalize Button */
.glass-fiscalize-btn {
  background: linear-gradient(
    135deg,
    rgba(255, 152, 0, 0.95) 0%,
    rgba(255, 193, 7, 0.9) 50%,
    rgba(255, 152, 0, 0.95) 100%
  ) !important;
  color: white !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 4px 16px rgba(255, 152, 0, 0.3) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  letter-spacing: 0.5px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.glass-fiscalize-btn:hover {
  background: linear-gradient(
    135deg,
    rgba(255, 152, 0, 1) 0%,
    rgba(255, 193, 7, 1) 50%,
    rgba(255, 152, 0, 1) 100%
  ) !important;
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 8px 24px rgba(255, 152, 0, 0.5) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

.glass-fiscalize-btn .v-icon {
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.glass-fiscalize-btn:hover .v-icon {
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.4));
}

/* Top Center Fiscalize Button */
.top-center-fiscalize-btn {
  position: fixed !important;
  top: 75px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  z-index: 100 !important;
  padding: 0 24px !important;
  height: 48px !important;
  background-color: #ef4444 !important;
  box-shadow: 0 8px 24px rgba(239, 68, 68, 0.5), 0 0 40px rgba(239, 68, 68, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.2) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  animation: pulse-glow-fiscalize 1.5s ease-in-out infinite;
}

.top-center-fiscalize-btn:hover {
  transform: translateX(-50%) scale(1.05) !important;
  background-color: #dc2626 !important;
  animation: pulse-glow-fiscalize-fast 0.8s ease-in-out infinite;
}

.top-center-fiscalize-btn .v-icon {
  color: white !important;
  font-size: 24px !important;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.3));
}

.top-center-fiscalize-btn .v-chip {
  font-weight: bold !important;
}

@keyframes pulse-glow-fiscalize {
  0%,
  100% {
    box-shadow: 0 8px 24px rgba(239, 68, 68, 0.5),
      0 0 40px rgba(239, 68, 68, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.2);
    transform: translateX(-50%) scale(0.95);
  }
  50% {
    box-shadow: 0 12px 40px rgba(239, 68, 68, 0.8),
      0 0 80px rgba(239, 68, 68, 0.6), inset 0 1px 0 rgba(255, 255, 255, 0.3);
    transform: translateX(-50%) scale(1.08);
  }
}

@keyframes pulse-glow-fiscalize-fast {
  0%,
  100% {
    box-shadow: 0 10px 30px rgba(239, 68, 68, 0.6),
      0 0 60px rgba(239, 68, 68, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.3);
    transform: translateX(-50%) scale(0.98);
  }
  50% {
    box-shadow: 0 15px 50px rgba(239, 68, 68, 0.9),
      0 0 100px rgba(239, 68, 68, 0.8), inset 0 1px 0 rgba(255, 255, 255, 0.4);
    transform: translateX(-50%) scale(1.12);
  }
}

/* eRačun Email Dialog Styling */
.glass-card-eracun {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.1) !important;
  overflow: hidden !important;
}

.glass-header-eracun {
  background: linear-gradient(
    135deg,
    rgba(0, 179, 190, 0.5) 0%,
    rgba(57, 137, 201, 0.45) 50%,
    rgba(97, 84, 164, 0.5) 100%
  ) !important;
  padding: 24px 24px 20px !important;
  position: relative !important;
}

.header-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.3;
  z-index: 0;
}

.headline-eracun {
  font-size: 20px !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
  position: relative !important;
  z-index: 1 !important;
  padding: 0 !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.glass-card-eracun .v-card__text {
  background: rgba(255, 255, 255, 0.5) !important;
}

/* Primary Button for eRačun Dialog */
.primary-btn-eracun {
  background: rgba(255, 255, 255, 0.8) !important;
  color: #3989c9 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(57, 137, 201, 0.15) !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px 24px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.primary-btn-eracun:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.25) !important;
  border-color: rgba(57, 137, 201, 0.3) !important;
  transform: translateY(-1px);
}

.primary-btn-eracun:disabled {
  opacity: 0.5 !important;
  background: rgba(245, 245, 245, 0.8) !important;
  color: rgba(158, 158, 158, 0.6) !important;
  border-color: rgba(200, 200, 200, 0.3) !important;
  box-shadow: none !important;
}

.primary-btn-eracun .v-icon {
  font-size: 18px !important;
  color: #3989c9 !important;
}

.primary-btn-eracun:disabled .v-icon {
  color: rgba(158, 158, 158, 0.6) !important;
}

/* Cancel Button for eRačun Dialog */
.cancel-btn-eracun {
  color: rgba(70, 70, 80, 0.7) !important;
  text-transform: none !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  transition: all 0.2s ease !important;
}

.cancel-btn-eracun:hover {
  color: rgba(70, 70, 80, 1) !important;
  background: rgba(0, 0, 0, 0.04) !important;
}

/* Filter Select Input for Email Field */
.filter-select {
  min-width: 0 !important;
}

.filter-select.v-text-field--outlined >>> fieldset {
  border-color: #B0BEC5 !important;
  border-width: 1.5px !important;
  border-radius: 8px !important;
}

.filter-select.v-text-field--outlined:hover >>> fieldset {
  border-color: #90A4AE !important;
}

.filter-select.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #00838F !important;
  border-width: 2px !important;
}

.filter-select >>> .v-input__slot {
  background: #ffffff !important;
  min-height: 38px !important;
  max-height: 38px !important;
  padding: 0 8px !important;
  border-radius: 8px !important;
}

.filter-select >>> .v-select__selection,
.filter-select >>> .v-text-field__slot input {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #263238 !important;
  letter-spacing: 0.3px !important;
}

.filter-select >>> label {
  font-size: 11px !important;
  font-weight: 500 !important;
  color: #37474F !important;
}
</style>

<style scoped>
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.new-receipt-fab {
  position: absolute;
  top: 1rem;
  right: 1rem;
}

/* Glass Filter Button */
.glass-filter-btn {
  background: linear-gradient(
    135deg,
    rgba(0, 179, 190, 0.9) 0%,
    rgba(57, 137, 201, 0.85) 50%,
    rgba(97, 84, 164, 0.9) 100%
  ) !important;
  color: white !important;
  border-radius: 50% !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 4px 12px rgba(0, 179, 190, 0.25) !important;
  backdrop-filter: blur(10px) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.glass-filter-btn:hover {
  background: linear-gradient(
    135deg,
    rgba(0, 179, 190, 1) 0%,
    rgba(57, 137, 201, 0.95) 50%,
    rgba(97, 84, 164, 1) 100%
  ) !important;
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 8px 20px rgba(0, 179, 190, 0.4) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

.glass-filter-btn .v-icon {
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

/* Glass Fiscalize Button - Compact */
.glass-fiscalize-btn {
  background: linear-gradient(
    135deg,
    rgba(255, 152, 0, 0.95) 0%,
    rgba(255, 193, 7, 0.9) 50%,
    rgba(255, 152, 0, 0.95) 100%
  ) !important;
  color: white !important;
  border-radius: 8px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.3) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  letter-spacing: 0.3px !important;
  height: 36px !important;
  padding: 0 16px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.glass-fiscalize-btn:hover {
  background: linear-gradient(
    135deg,
    rgba(255, 152, 0, 1) 0%,
    rgba(255, 193, 7, 1) 50%,
    rgba(255, 152, 0, 1) 100%
  ) !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.4) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

.glass-fiscalize-btn .v-icon {
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  font-size: 18px !important;
}

.glass-fiscalize-btn:hover .v-icon {
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.3));
}

/* Table Header with Filters - Fixed Sticky */
.table-header-filters {
  position: -webkit-sticky;
  position: sticky;
  top: 64px;
  z-index: 8;
  background: #ffffff;
  padding: 14px 16px 16px;
  margin-bottom: 0;
  border-bottom: 1px solid #EEF2F5;
  border-left: 3px solid #00BCD4;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  box-sizing: border-box;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
}

.advanced-filters-panel {
  border-top: 1px solid #EEF2F5;
  margin-top: 12px;
}

/* Shared 5-column grid — used by both the primary row and the advanced row */
.toolbar-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  align-items: center;
}

/* Force every direct grid child to the center baseline */
.toolbar-grid > * {
  align-self: center;
  margin-top: 0 !important;
}

/* Action cluster — left-aligned so buttons sit immediately after Prodajna mjesta */
.toolbar-grid__actions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  align-self: center !important;
  margin-left: 8px;
}

@media (max-width: 900px) {
  .toolbar-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .toolbar-grid__actions {
    justify-content: flex-start;
  }
}

.advanced-toggle-btn {
  height: 38px !important;
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  color: #3989C9 !important;
  text-transform: none !important;
  letter-spacing: 0.2px !important;
  padding: 0 8px !important;
  min-width: unset !important;
  opacity: 0.75;
}

.advanced-toggle-btn:hover {
  opacity: 1;
  background: transparent !important;
  box-shadow: none !important;
}

.pagination-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px 0;
  border-top: 1px solid #EDF2F7;
  margin-top: 4px;
}

.pagination-info {
  font-size: 13px;
  color: #718096;
  font-weight: 500;
}

/* Grey wrapper — creates floating card separation between rows */
.receipts-rows-body {
  background: #F5F7FA;
  padding: 6px 0 2px;
}

.receipts-rows-body .v-expansion-panels {
  background: transparent !important;
}

.receipts-rows-body .v-expansion-panel:first-child {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

/* Filter Select Inputs */
.filter-select.v-text-field--outlined >>> fieldset {
  border-color: #B0BEC5 !important;
  border-width: 1.5px !important;
  border-radius: 8px !important;
}

.filter-select.v-text-field--outlined:hover >>> fieldset {
  border-color: #90A4AE !important;
}

.filter-select.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #00838F !important;
  border-width: 2px !important;
}

.filter-select {
  min-width: 0 !important;
}

.filter-select >>> .v-input__slot {
  background: #ffffff !important;
  min-height: 38px !important;
  max-height: 38px !important;
  padding: 0 8px !important;
  border-radius: 8px !important;
}

.filter-select.v-text-field--outlined >>> .v-input__control {
  height: 38px !important;
  border-radius: 8px !important;
}

.filter-select.v-text-field--outlined >>> .v-text-field__slot {
  height: 38px !important;
  border-radius: 8px !important;
}

.filter-select >>> .v-select__selection,
.filter-select >>> .v-text-field__slot input {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #263238 !important;
  letter-spacing: 0.3px !important;
}

.filter-select >>> label {
  font-size: 11px !important;
  font-weight: 500 !important;
  color: #37474F !important;
}

/* Calendar & all input icons */
.filter-select >>> .v-input__prepend-inner {
  display: flex !important;
  align-items: center !important;
  align-self: center !important;
  margin-top: 0 !important;
}

.filter-select >>> .v-input__prepend-inner .v-icon,
.filter-select >>> .v-input__append-inner .v-icon {
  color: #455A64 !important;
}

/* Calendar icon — tirkizna accent */
.filter-select >>> .v-input__prepend-inner .v-icon {
  color: #00BCD4 !important;
}

/* Filter Select Dropdown Menu */
.filter-select >>> .v-menu__content {
  background: rgba(255, 255, 255, 0.98) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 8px !important;
  border: 1px solid rgba(0, 179, 190, 0.15) !important;
  box-shadow: 0 8px 24px rgba(0, 179, 190, 0.12) !important;
}

.filter-select >>> .v-list-item {
  font-size: 13px !important;
  font-weight: 500 !important;
  transition: all 0.2s ease !important;
}

.filter-select >>> .v-list-item:hover {
  background: rgba(57, 137, 201, 0.08) !important;
}

.filter-select >>> .v-list-item--active {
  background: rgba(0, 179, 190, 0.12) !important;
  color: #3989c9 !important;
}

/* Search Button - Outlined Tirkizna */
.search-btn {
  align-self: center !important;
  margin-top: 0 !important;
  background: rgba(0, 188, 212, 0.08) !important;
  color: #00838F !important;
  border: 1.2px solid #00b3be !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  transition: background 0.15s ease !important;
  padding: 0 16px !important;
  height: 38px !important;
  min-height: 38px !important;
  max-height: 38px !important;
  min-width: 100px !important;
  font-weight: 600 !important;
  margin: 0 !important;
  text-transform: none !important;
  font-size: 13px !important;
  letter-spacing: 0.3px !important;
  overflow: hidden !important;
}

.search-btn:hover {
  background: rgba(0, 179, 190, 0.12) !important;
  box-shadow: none !important;
}

.search-btn::before {
  box-shadow: none !important;
}

.search-btn .v-icon {
  color: #00BCD4 !important;
  font-size: 17px !important;
}

/* Pagination Row in Header */
.pagination-row {
  padding-top: 8px;
  border-top: 1px solid rgba(0, 179, 190, 0.15);
}

/* Navigation Buttons in Header - Clean White Style */
.page-nav-btn-header {
  background: rgba(255, 255, 255, 0.95) !important;
  color: #3989c9 !important;
  border: 1px solid rgba(57, 137, 201, 0.25) !important;
  border-radius: 8px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
  backdrop-filter: blur(10px) !important;
  transition: all 0.2s ease !important;
  text-transform: none !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  letter-spacing: 0.3px !important;
  padding: 0 16px !important;
  height: 36px !important;
  min-width: 110px !important;
  margin: 0 4px !important;
}

.page-nav-btn-header:hover:not(:disabled) {
  background: rgba(255, 255, 255, 1) !important;
  border-color: #3989c9 !important;
  box-shadow: 0 2px 6px rgba(57, 137, 201, 0.2) !important;
  transform: translateY(-1px);
}

.page-nav-btn-header:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
  background: rgba(245, 245, 245, 0.8) !important;
  border-color: rgba(200, 200, 200, 0.3) !important;
  color: rgba(158, 158, 158, 0.6) !important;
}

.page-nav-btn-header .v-icon {
  color: #3989c9 !important;
  font-size: 18px !important;
}

.page-nav-btn-header:disabled .v-icon {
  color: rgba(158, 158, 158, 0.6) !important;
}

/* Loading Overlay - samo na receipts */
.loading-overlay-receipts {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(10px) !important;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  border-radius: 16px !important;
  min-height: 400px;
}

.loading-spinner {
  color: #3989c9 !important;
}

/* Expansion Panel Icon Rotation */
.v-expansion-panel-header .v-icon {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.v-expansion-panel--active > .v-expansion-panel-header .v-icon {
  transform: rotate(90deg) !important;
}

.v-expansion-panel-header .v-icon:hover {
  transform: rotate(90deg) !important;
}

/* ── Active / expanded panel ────────────────────────────── */

/* Expanded content area — matches active panel background */
.v-expansion-panel--active > .v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  background: #F7FBFC;
  padding-left: 40px !important;
  padding-top: 8px !important;
  padding-bottom: 12px !important;
}

/* Inner column headers (R.br., Naziv, Količina...) — small branded labels */
.v-expansion-panel-content .font-weight-bold.text-subtitle-2 {
  font-size: 11px !important;
  color: #004D58 !important;
  font-weight: 600 !important;
  letter-spacing: 0.4px !important;
  text-transform: uppercase;
}

/* PDV/PNP breakdown table */
.pdv-breakdown-table {
  border-collapse: collapse;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  font-size: 12px;
}

.pdv-breakdown-table th,
.pdv-breakdown-table td {
  padding: 5px 12px;
  text-align: right;
  white-space: nowrap;
  color: #004D58;
}

.pdv-breakdown-table th {
  font-size: 11px;
  font-weight: 600;
  color: #004D58;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  border-bottom: 1px solid rgba(0, 77, 88, 0.12);
}

.pdv-breakdown-table th:first-child,
.pdv-breakdown-table td:first-child {
  text-align: left;
}

.pdv-breakdown-table td.pdv-label {
  font-weight: 600;
  color: #004D58;
}

.pdv-breakdown-table tbody tr {
  background: #ffffff !important;
}

.pdv-breakdown-table tbody tr + tr {
  border-top: 1px solid rgba(0, 77, 88, 0.07);
}

/* Column labels inside expansion panel headers */
.v-expansion-panel-header .caption.grey--text {
  color: #37474F !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  letter-spacing: 0.2px !important;
}

/* Badge in toggle button — perfect vertical centering */
.advanced-toggle-btn >>> .v-badge {
  vertical-align: middle !important;
}

.advanced-toggle-btn >>> .v-badge__badge {
  font-size: 10px !important;
  height: 16px !important;
  min-width: 16px !important;
  padding: 0 4px !important;
}

/* Search button content centering */
.search-btn >>> .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 4px !important;
  line-height: 1 !important;
}

/* Left backbone — status-coloured thin stripe */
.v-expansion-panel {
  border: 1px solid #EEF2F5 !important;
  border-left: 3px solid #E0E0E0 !important;
  border-radius: 6px !important;
  background: #ffffff !important;
  box-shadow: none !important;
  overflow: hidden !important;
  transition: border-left-color 0.15s ease, border-color 0.15s ease, background 0.15s ease !important;
  margin-bottom: 4px !important;
}

.v-expansion-panel::before,
.v-expansion-panel::after {
  box-shadow: none !important;
  display: none !important;
}

/* Remove Vuetify's extra margin-top on active/next-active panels */
.v-expansion-panel--active + .v-expansion-panel,
.v-expansion-panel--next-active {
  margin-top: 0 !important;
}

/* Hover on inactive panels */
.v-expansion-panel:not(.v-expansion-panel--active):hover {
  border-color: #00BCD4 !important;
  background: #F8FAFB !important;
}

/* Expanded / active panel — teal accent + very light background lift */
.v-expansion-panel--active {
  border-left-color: #00BCD4 !important;
  border-color: #B2EBF2 !important;
  background: #F7FBFC !important;
}

/* Compact header — tighter height and padding */
.v-expansion-panel >>> .v-expansion-panel-header {
  padding-left: 16px !important;
  min-height: 60px !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

/* Status-specific border colours */
.status-ok-exp         { border-left-color: #4CAF50 !important; }
.status-warn-exp       { border-left-color: #FF9800 !important; }
.status-warn-after-exp { border-left-color: #F57C00 !important; }
.status-failed-exp     { border-left-color: #F44336 !important; }
.status-failed-expired { border-left-color: #C62828 !important; }
.status-storno         { border-left-color: #78909C !important; }
.status-reversed       { border-left-color: #6154A4 !important; }
.status-uncollectible  { border-left-color: #546E7A !important; }

/* All status rows: white background */
.status-ok-exp,
.status-warn-exp,
.status-warn-after-exp,
.status-failed-exp,
.status-failed-expired,
.status-storno,
.status-reversed,
.status-uncollectible {
  background: #ffffff !important;
}

/* Status dot — small coloured circle before status text */
.receipt-status-value {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  font-size: 12px;
}

.receipt-status-value--offer {
  font-size: 13px;
}

.receipt-status-value::after {
  content: '';
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.status-ok-exp          .receipt-status-value::after { background: #4CAF50; }
.status-warn-exp        .receipt-status-value::after { background: #FF9800; }
.status-warn-after-exp  .receipt-status-value::after { background: #F57C00; }
.status-failed-exp      .receipt-status-value::after { background: #F44336; }
.status-failed-expired  .receipt-status-value::after { background: #C62828; }
.status-storno          .receipt-status-value::after { background: #78909C; }
.status-reversed        .receipt-status-value::after { background: #6154A4; }
.status-uncollectible   .receipt-status-value::after { background: #546E7A; }

/* Amount — bold financial figures */
.receipt-amount-value {
  font-weight: 700 !important;
}

/* Receipt number — bold for hierarchy */
.receipt-number-value {
  font-weight: 700 !important;
}

/* Virman border colours — override status classes */
.virman-paid   { border-left-color: #4CAF50 !important; }
.virman-unpaid { border-left-color: #FF9800 !important; }
</style>
